import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { useFetcher } from './fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export enum Action {
  Call = 'CALL',
  Email = 'EMAIL',
  Sms = 'SMS',
}

export type AdminInvoices = {
  __typename?: 'AdminInvoices';
  results: Array<Invoice>;
  totalCount: Scalars['Int']['output'];
};

export type AdminScenarios = {
  __typename?: 'AdminScenarios';
  results: Array<Scenario>;
  totalCount: Scalars['Int']['output'];
};

export type AdminUserInput = {
  plan?: InputMaybe<UserPlan>;
  role?: InputMaybe<Role>;
};

export type AdminUsers = {
  __typename?: 'AdminUsers';
  results: Array<User>;
  totalCount: Scalars['Int']['output'];
};

export type ArchiveResult = {
  __typename?: 'ArchiveResult';
  /** IDs of invoices that couldn't be archived. */
  failed: Array<Scalars['String']['output']>;
};

export type AresResult = {
  __typename?: 'AresResult';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AttachClaimsToBatchUploadInput = {
  batchUploadId: Scalars['String']['input'];
  claims: Array<BatchedClaimInput>;
  scenarioId: Scalars['String']['input'];
};

export type AttachInvoicesToBatchUploadInput = {
  batchUploadId: Scalars['String']['input'];
  invoices: Array<BatchedInvoiceInput>;
  scenarioId: Scalars['String']['input'];
};

export type AuthenticateBankInput = {
  /** URL to redirect user to after successful authentication. */
  callbackUrl: Scalars['String']['input'];
  paymentProvider: Scalars['String']['input'];
};

export type Bank = {
  __typename?: 'Bank';
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentProvider: Scalars['String']['output'];
};

export type BankAuthentication = {
  __typename?: 'BankAuthentication';
  /** Bank authentication URL */
  redirectUrl: Scalars['String']['output'];
};

export type BankConnection = {
  __typename?: 'BankConnection';
  bankLogoUrl?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  status: BankConnectionStatus;
};

export enum BankConnectionStatus {
  Expired = 'EXPIRED',
  Valid = 'VALID',
}

export type BankTransaction = {
  __typename?: 'BankTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  debtorAccount?: Maybe<Scalars['String']['output']>;
  debtorAccountName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export enum BatchInvoiceUploadCategory {
  AlreadyCompleted = 'ALREADY_COMPLETED',
  Archived = 'ARCHIVED',
  Ignored = 'IGNORED',
  New = 'NEW',
  PartiallySettled = 'PARTIALLY_SETTLED',
  Reminding = 'REMINDING',
  Settled = 'SETTLED',
}

export type BatchUpload = {
  __typename?: 'BatchUpload';
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  invoices: Array<Invoice>;
  invoicesCount: Scalars['Int']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  planPaid: Scalars['Boolean']['output'];
  /** Final price including discount */
  price?: Maybe<Scalars['Int']['output']>;
  scenario?: Maybe<Scenario>;
  type: BatchUploadType;
};

export type BatchUploadDiscountArgs = {
  plan: Plan;
};

export type BatchUploadPriceArgs = {
  plan: Plan;
};

export enum BatchUploadType {
  Export = 'EXPORT',
  Pdf = 'PDF',
}

export type BatchedClaimInput = {
  amount: Scalars['Int']['input'];
  amountDue: Scalars['Int']['input'];
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customer: CustomerCreateInput;
  dueDate: Scalars['DateTime']['input'];
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendor: VendorCreateInput;
};

export type BatchedInvoiceInput = {
  amount: Scalars['Int']['input'];
  amountDue: Scalars['Int']['input'];
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  issueDate: Scalars['DateTime']['input'];
  number: Scalars['String']['input'];
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmInvoiceInput = {
  amount: Scalars['Int']['input'];
  amountDue: Scalars['Int']['input'];
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  issueDate: Scalars['DateTime']['input'];
  items: Array<InvoiceItemInput>;
  number: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateBatchUploadInput = {
  type: BatchUploadType;
};

export type CreateInvoiceManuallyInput = {
  /** Total with VAT */
  amount: Scalars['Int']['input'];
  /** Total VAT */
  amountVat?: InputMaybe<Scalars['Int']['input']>;
  /** Total without VAT */
  amountWithoutVat?: InputMaybe<Scalars['Int']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['DateTime']['input'];
  items: Array<InvoiceItemInput>;
  number: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  taxPayer: Scalars['Boolean']['input'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: InputMaybe<Scalars['DateTime']['input']>;
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateInvoicesFromMappedDataInput = {
  invoices: Scalars['JSON']['input'];
  scenarioId: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  remindingTone: RemindingTone;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type CustomerCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  remindingTone?: InputMaybe<RemindingTone>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  remindingTone?: InputMaybe<RemindingTone>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type EditInvoiceInput = {
  /** Total with VAT */
  amount: Scalars['Int']['input'];
  /** Total VAT */
  amountVat?: InputMaybe<Scalars['Int']['input']>;
  /** Total without VAT */
  amountWithoutVat?: InputMaybe<Scalars['Int']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  issueDate: Scalars['DateTime']['input'];
  items: Array<InvoiceItemInput>;
  number: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  taxPayer: Scalars['Boolean']['input'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: InputMaybe<Scalars['DateTime']['input']>;
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type EscalateUnpaidInvoiceInput = {
  invoiceId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amount?: Maybe<Scalars['Int']['output']>;
  amountDue?: Maybe<Scalars['Int']['output']>;
  amountVat?: Maybe<Scalars['Int']['output']>;
  amountWithoutVat?: Maybe<Scalars['Int']['output']>;
  annotationComplete: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankNumber?: Maybe<Scalars['String']['output']>;
  bankTransactions: Array<BankTransaction>;
  batchUpload?: Maybe<BatchUpload>;
  batchUploadId?: Maybe<Scalars['String']['output']>;
  canBeArchived: Scalars['Boolean']['output'];
  claim: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdManually: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  customerNote?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Is true if the invoice was processed in Rossum, otherwise false. */
  isAnnotated: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  items: Array<InvoiceItem>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  owner: User;
  paymentId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  planPaid: Scalars['Boolean']['output'];
  /** Final price for reminding of this invoice including discount. */
  price?: Maybe<Scalars['Int']['output']>;
  remindingTone: RemindingTone;
  scenario?: Maybe<Scenario>;
  scheduledActions: Array<ScheduledAction>;
  settled: Scalars['Boolean']['output'];
  status: InvoiceStatus;
  swift?: Maybe<Scalars['String']['output']>;
  taxPayer: Scalars['Boolean']['output'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: Maybe<Scalars['DateTime']['output']>;
  variableSymbol?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Vendor>;
};

export type InvoiceDiscountArgs = {
  plan: Plan;
};

export type InvoicePriceArgs = {
  plan: Plan;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  name: Scalars['String']['output'];
  pricePerUnit: Scalars['Int']['output'];
  priceSum: Scalars['Int']['output'];
  priceWithoutVat?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type InvoiceItemInput = {
  name: Scalars['String']['input'];
  pricePerUnit: Scalars['Int']['input'];
  priceSum: Scalars['Int']['input'];
  priceWithoutVat?: InputMaybe<Scalars['Int']['input']>;
  quantity?: Scalars['Float']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

/** A model is a hard-coded object created by developers directly for a specific input data format (e.g. XML export from Pohoda accounting software). The model contains logic on how to read input data and how to create invoices from it. */
export type InvoiceModel = {
  __typename?: 'InvoiceModel';
  fields: Array<InvoiceModelField>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InvoiceModelField = {
  __typename?: 'InvoiceModelField';
  name: ModelFieldName;
  required: Scalars['Boolean']['output'];
};

export enum InvoiceStatus {
  Archived = 'ARCHIVED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingVerification = 'AWAITING_VERIFICATION',
  Complete = 'COMPLETE',
  MissingRequiredData = 'MISSING_REQUIRED_DATA',
  Processing = 'PROCESSING',
  Reminding = 'REMINDING',
  Settled = 'SETTLED',
}

export type LeadCustomerModel = {
  __typename?: 'LeadCustomerModel';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  remindingTone: RemindingTone;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type LeadInput = {
  email: Scalars['String']['input'];
  invoice: LeadInvoiceInput;
};

export type LeadInvoiceCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type LeadInvoiceInput = {
  /** centesimal amount */
  amount: Scalars['Int']['input'];
  /** Total VAT */
  amountVat?: InputMaybe<Scalars['Int']['input']>;
  /** Total without VAT */
  amountWithoutVat?: InputMaybe<Scalars['Int']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customer: LeadInvoiceCustomerInput;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<InvoiceItemInput>;
  number: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  taxPayer: Scalars['Boolean']['input'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: InputMaybe<Scalars['DateTime']['input']>;
  variableSymbol: Scalars['String']['input'];
  vendor: LeadInvoiceVendorInput;
};

export type LeadInvoiceModel = {
  __typename?: 'LeadInvoiceModel';
  amount?: Maybe<Scalars['Int']['output']>;
  amountDue?: Maybe<Scalars['Int']['output']>;
  amountVat?: Maybe<Scalars['Int']['output']>;
  amountWithoutVat?: Maybe<Scalars['Int']['output']>;
  annotationComplete: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankNumber?: Maybe<Scalars['String']['output']>;
  batchUploadId?: Maybe<Scalars['String']['output']>;
  claim: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdManually: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer: LeadCustomerModel;
  customerNote?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  items: Array<InvoiceItem>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  planPaid: Scalars['Boolean']['output'];
  remindingTone: RemindingTone;
  settled: Scalars['Boolean']['output'];
  swift?: Maybe<Scalars['String']['output']>;
  taxPayer: Scalars['Boolean']['output'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: Maybe<Scalars['DateTime']['output']>;
  variableSymbol?: Maybe<Scalars['String']['output']>;
  vendor: LeadVendorModel;
};

export type LeadInvoiceVendorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registry?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type LeadVendorModel = {
  __typename?: 'LeadVendorModel';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  registry?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export enum MessageKind {
  Sms = 'SMS',
}

export enum ModelFieldName {
  Co = 'CO',
  Email = 'EMAIL',
  Identifikator = 'IDENTIFIKATOR',
  Kam = 'KAM',
  Kdy = 'KDY',
  Kolik = 'KOLIK',
  Telefon = 'TELEFON',
  Upominany = 'UPOMINANY',
  Varsymbol = 'VARSYMBOL',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Bulk archive invoice. Returns ID of invoices that couldn't be archived. Invoice with status REMINDING can't be archived, reminding must be ended first. */
  archive: ArchiveResult;
  /** Attaches claims to existing batch upload (created with `createBatchUpload`). To get the structured data of tha claims, use the `/upload-xml` endpoint. */
  attachClaimsToBatchUpload: BatchUpload;
  /** Attaches invoices to existing batch upload (created with `createBatchUpload`). To get the structured data of the invoices, use the `/upload-xml` endpoint. */
  attachInvoicesToBatchUpload: BatchUpload;
  /** Updates invoice and marks it as verified. Used to provide details for invoices uploaded via rossum.ai. Once verified, the invoice is ready to be paid as long as it has all the required details. */
  confirmInvoice: Invoice;
  /** Returns bank authentication URL. Redirect user to that URL and let him to authenticate to his bank. After successful authentication the user is redirected to `callbackUrl`. */
  connectBank: BankAuthentication;
  /** Create a payment for a batch upload. Returns Stripe client secret if payment is required, otherwise returns null. */
  createBatchPayment: PlanPayment;
  /** Creates a new empty batch upload, you can then add invoices to it. */
  createBatchUpload: BatchUpload;
  /** Create a new customer. */
  createCustomer: Customer;
  /** Creates a new blank invoice. */
  createInvoice: Invoice;
  /** Creates a new invoice. */
  createInvoiceManually: Invoice;
  /** Accepts invoices data in JSON format and scenario according to which the data will be processed. Invoices data must be compatible with the scenario's model (check fields available on the model). It is good for when you have your data in custom table-like format - just map you columns to model's fieldsand load it (creation of custom model and scenario might be needed). */
  createInvoicesFromJson: BatchUpload;
  /** Save lead with invoice data. */
  createLead?: Maybe<LeadInvoiceModel>;
  /** Create a payment for single invoice. Returns Stripe client secret if payment is required, otherwise returns null. */
  createPayment: PlanPayment;
  /** Create new scenario. Only back-office user can do this. */
  createScenario: Scenario;
  /** Create a new vendor. */
  createVendor: Vendor;
  /** Delete existing scenario. Only back-office user can do this. */
  deleteScenario: Scalars['String']['output'];
  /** Remove consent for contacting the user regarding the unsupported file. Use ID from the upload response. */
  denyUnsupportedFileContactConsent?: Maybe<SuccessResult>;
  /** Revokes bank authentication and removes the bank connection record. */
  disconnectBank: Scalars['String']['output'];
  /** Edits manually created invoice. */
  editInvoice: Invoice;
  /** Marks all scheduled actions of the invoice as completed. */
  endReminding: Invoice;
  /** Request for help with unpaid invoice. Sends e-mail to back office. Back office user can then contact the requester to agree on the next steps. */
  escalateUnpaidInvoice: Scalars['Boolean']['output'];
  /** Request new plan for invoice. Only available for invoices with trial plan. */
  requestNewPlan: Invoice;
  /** Resend verification email for the current user. */
  resendVerificationEmail: Scalars['Boolean']['output'];
  /** Changes the due amount of the invoice. If set to 0, the invoice is marked as paid and all the scheduled actions are marked as completed. */
  setDueAmount: Invoice;
  /** Update role/plan of any user. */
  updateAdminUser: User;
  /** Update existing customer. */
  updateCustomer: Customer;
  /** Update existing scenario. Only back-office user can do this. */
  updateScenario: Scenario;
  /** Updates a scheduled action. */
  updateScheduledAction: ScheduledAction;
  /** Update current user. */
  updateUser: User;
  /** Update existing vendor. */
  updateVendor: Vendor;
};

export type MutationArchiveArgs = {
  invoiceIds: Array<Scalars['String']['input']>;
};

export type MutationAttachClaimsToBatchUploadArgs = {
  input: AttachClaimsToBatchUploadInput;
};

export type MutationAttachInvoicesToBatchUploadArgs = {
  input: AttachInvoicesToBatchUploadInput;
};

export type MutationConfirmInvoiceArgs = {
  input: ConfirmInvoiceInput;
};

export type MutationConnectBankArgs = {
  input: AuthenticateBankInput;
};

export type MutationCreateBatchPaymentArgs = {
  id: Scalars['String']['input'];
  plan: Plan;
};

export type MutationCreateBatchUploadArgs = {
  input: CreateBatchUploadInput;
};

export type MutationCreateCustomerArgs = {
  customer: CustomerCreateInput;
};

export type MutationCreateInvoiceManuallyArgs = {
  input: CreateInvoiceManuallyInput;
};

export type MutationCreateInvoicesFromJsonArgs = {
  input: CreateInvoicesFromMappedDataInput;
};

export type MutationCreateLeadArgs = {
  input: LeadInput;
};

export type MutationCreatePaymentArgs = {
  id: Scalars['String']['input'];
  plan: Plan;
};

export type MutationCreateScenarioArgs = {
  input: ScenarioCreateInput;
};

export type MutationCreateVendorArgs = {
  vendor: VendorCreateInput;
};

export type MutationDeleteScenarioArgs = {
  id: Scalars['String']['input'];
};

export type MutationDenyUnsupportedFileContactConsentArgs = {
  id: Scalars['String']['input'];
};

export type MutationDisconnectBankArgs = {
  id: Scalars['String']['input'];
};

export type MutationEditInvoiceArgs = {
  input: EditInvoiceInput;
};

export type MutationEndRemindingArgs = {
  invoiceId: Scalars['String']['input'];
};

export type MutationEscalateUnpaidInvoiceArgs = {
  input: EscalateUnpaidInvoiceInput;
};

export type MutationRequestNewPlanArgs = {
  id: Scalars['String']['input'];
};

export type MutationSetDueAmountArgs = {
  amountDue: Scalars['Float']['input'];
  id: Scalars['String']['input'];
};

export type MutationUpdateAdminUserArgs = {
  id: Scalars['String']['input'];
  input: AdminUserInput;
};

export type MutationUpdateCustomerArgs = {
  customer: CustomerUpdateInput;
};

export type MutationUpdateScenarioArgs = {
  input: ScenarioUpdateInput;
};

export type MutationUpdateScheduledActionArgs = {
  input: ScheduledActionUpdateInput;
};

export type MutationUpdateUserArgs = {
  input: UserInput;
};

export type MutationUpdateVendorArgs = {
  vendor: VendorUpdateInput;
};

export enum Plan {
  Standard = 'STANDARD',
  Trial = 'TRIAL',
}

export type PlanPayment = {
  __typename?: 'PlanPayment';
  clientSecret?: Maybe<Scalars['String']['output']>;
  paymentRequired: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Get any invoice by id. Only available for back-office users with correct permissions. */
  adminInvoice: Invoice;
  /** Get all invoices. Only available for back-office users with correct permissions. */
  adminInvoices: AdminInvoices;
  /** Get any scenario by id. Only available for back-office users with correct permissions. */
  adminScenario: Scenario;
  /** Get all scenarios. Only available for back-office users with correct permissions. */
  adminScenarios: AdminScenarios;
  /** List users. Only available for back-office users with correct permissions. */
  adminUsers: AdminUsers;
  /** Get status of the auth. */
  authStatus: Scalars['String']['output'];
  /** A helper query to provide the BatchInvoiceUploadCategory enum to the client. This is used in `category` attribute of /upload-xml endpoint. */
  availableBatchInvoiceUploadCategories: BatchInvoiceUploadCategory;
  /** Get list of your connected banks. */
  bankConnections: Array<BankConnection>;
  /** Get batch upload by id. */
  batchUpload: BatchUpload;
  /** Get customer by id. */
  customer: Customer;
  /** Get all customers for current user. */
  customers: Array<Customer>;
  /** Get invoice by id. */
  invoice: Invoice;
  /** Get all models available to be used with scenarios. */
  invoiceModels: Array<InvoiceModel>;
  /** Get all invoices for current user. */
  invoices: Array<Invoice>;
  /** Get lead invoice data by id. */
  leadInvoice: LeadInvoiceModel;
  /** Query ARES service for structured information about provided vatId (IČ). Provider's API has a rate limitation and could result in permanent ban if abused - use this query accordingly. */
  queryAres?: Maybe<AresResult>;
  /** Gets all received messages. */
  receivedMessages: Array<ReceivedMessage>;
  /** Get scenario by id. */
  scenario: Scenario;
  /** Get list of available scenario plans. */
  scenarioPlans: Array<ScenarioPlan>;
  /** Get scenarios for current user. */
  scenarios: Array<Scenario>;
  /** Gets a single scheduled action by id. */
  scheduledAction: ScheduledAction;
  /** Gets all actions scheduled to be performed today. */
  scheduledActionsDoneToday: Array<ScheduledAction>;
  /** Gets all actions scheduled to be performed today, or unfinished from earlier. */
  scheduledActionsForToday: Array<ScheduledAction>;
  /** Get status of the API. */
  status: Scalars['String']['output'];
  /** Get list of banks supported by FinBricks. */
  supportedBanks: Array<Bank>;
  /** Get current user. */
  user: User;
  /** Get vendor by id. */
  vendor: Vendor;
  /** Get all vendors for current user. */
  vendors: Array<Vendor>;
};

export type QueryAdminInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};

export type QueryAdminInvoicesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  claim?: InputMaybe<Scalars['Boolean']['input']>;
  query?: Scalars['String']['input'];
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type QueryAdminScenarioArgs = {
  id: Scalars['String']['input'];
};

export type QueryAdminScenariosArgs = {
  query?: Scalars['String']['input'];
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type QueryAdminUsersArgs = {
  query?: Scalars['String']['input'];
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type QueryBatchUploadArgs = {
  id: Scalars['String']['input'];
};

export type QueryCustomerArgs = {
  id: Scalars['String']['input'];
};

export type QueryInvoiceArgs = {
  id: Scalars['String']['input'];
};

export type QueryInvoicesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  claim?: InputMaybe<Scalars['Boolean']['input']>;
  createdManually?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryLeadInvoiceArgs = {
  id: Scalars['String']['input'];
};

export type QueryQueryAresArgs = {
  vatId: Scalars['String']['input'];
};

export type QueryScenarioArgs = {
  id: Scalars['String']['input'];
};

export type QueryScheduledActionArgs = {
  id: Scalars['String']['input'];
};

export type QueryVendorArgs = {
  id: Scalars['String']['input'];
};

/** Represents SMS message sent to Upominej phone number. */
export type ReceivedMessage = {
  __typename?: 'ReceivedMessage';
  createdAt: Scalars['DateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: MessageKind;
  receivedAt: Scalars['DateTime']['output'];
  relevantScheduledActions: Array<ScheduledAction>;
  text: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export enum RemindingTone {
  Firm = 'FIRM',
  Neutral = 'NEUTRAL',
  Polite = 'POLITE',
}

export enum Role {
  Admin = 'ADMIN',
  User = 'USER',
}

/** The scenario is used to customize reminding to user's needs. You can define your own reminding texts. Scenarios are created by back-office user in cooperation with the user. */
export type Scenario = {
  __typename?: 'Scenario';
  id: Scalars['String']['output'];
  model: InvoiceModel;
  name: Scalars['String']['output'];
  plan: ScenarioPlan;
  static: Scalars['Boolean']['output'];
  subject: Array<Scalars['String']['output']>;
  textCall: Array<Scalars['String']['output']>;
  textEmail: Array<Scalars['String']['output']>;
  textSms: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ScenarioCreateInput = {
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  plan: ScenarioPlanName;
  subject: Array<Scalars['String']['input']>;
  textCall: Array<Scalars['String']['input']>;
  textEmail: Array<Scalars['String']['input']>;
  textSms: Array<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ScenarioPlan = {
  __typename?: 'ScenarioPlan';
  call: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  name: ScenarioPlanName;
  sms: Scalars['Int']['output'];
};

export enum ScenarioPlanName {
  Plan_321 = 'PLAN_321',
  Plan_331 = 'PLAN_331',
  Plan_551 = 'PLAN_551',
}

export type ScenarioUpdateInput = {
  id: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  plan: ScenarioPlanName;
  subject: Array<Scalars['String']['input']>;
  textCall: Array<Scalars['String']['input']>;
  textEmail: Array<Scalars['String']['input']>;
  textSms: Array<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledAction = {
  __typename?: 'ScheduledAction';
  action: Action;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  invoice: Invoice;
  invoiceClaim: Scalars['Boolean']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  recommendedMessage?: Maybe<Scalars['String']['output']>;
  recommendedSubject?: Maybe<Scalars['String']['output']>;
  scheduledAt: Scalars['DateTime']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
  templateNoPayment?: Maybe<Scalars['String']['output']>;
  templatePartialPayment?: Maybe<Scalars['String']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type ScheduledActionUpdateInput = {
  doneAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankNumber?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  defaultRemindingTone: RemindingTone;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plan: UserPlan;
  remindersCount: Scalars['Int']['output'];
  remindersLimit?: Maybe<Scalars['Int']['output']>;
  role: Role;
  streetAddress?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  /** DIČ */
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  defaultRemindingTone?: InputMaybe<RemindingTone>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  /** DIČ */
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum UserPlan {
  Complete = 'COMPLETE',
  Optimal = 'OPTIMAL',
  Trial = 'TRIAL',
}

export type Vendor = {
  __typename?: 'Vendor';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type VendorCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type VendorUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type BatchUploadFragment = {
  __typename?: 'BatchUpload';
  id: string;
  plan?: Plan | null;
  invoicesCount: number;
  planPaid: boolean;
  standardPrice?: number | null;
  standardDiscount?: number | null;
  scenario?: {
    __typename?: 'Scenario';
    id: string;
    plan: { __typename?: 'ScenarioPlan'; name: ScenarioPlanName; email: number; sms: number; call: number };
  } | null;
};

export type BatchUploadStatusFragment = {
  __typename?: 'BatchUpload';
  id: string;
  invoices: Array<{
    __typename?: 'Invoice';
    id: string;
    status: InvoiceStatus;
    number?: string | null;
    createdAt: any;
  }>;
};

export type ClaimFragmentFragment = {
  __typename?: 'Invoice';
  id: string;
  name?: string | null;
  canBeArchived: boolean;
  number?: string | null;
  amount?: number | null;
  amountDue?: number | null;
  amountVat?: number | null;
  amountWithoutVat?: number | null;
  taxPayer: boolean;
  taxPoint?: any | null;
  settled: boolean;
  currency?: string | null;
  createdAt: any;
  bankAccount?: string | null;
  bankNumber?: string | null;
  iban?: string | null;
  swift?: string | null;
  annotationComplete: boolean;
  customerNote?: string | null;
  issueDate?: any | null;
  dueDate?: any | null;
  variableSymbol?: string | null;
  status: InvoiceStatus;
  plan?: Plan | null;
  planPaid: boolean;
  remindingTone: RemindingTone;
  isAnnotated: boolean;
  downloadUrl?: string | null;
  scenario?: { __typename?: 'Scenario'; id: string } | null;
  customer?: {
    __typename?: 'Customer';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    remindingTone: RemindingTone;
  } | null;
  vendor?: {
    __typename?: 'Vendor';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
  } | null;
  scheduledActions: Array<{
    __typename?: 'ScheduledAction';
    id: string;
    scheduledAt: any;
    action: Action;
    doneAt?: any | null;
    cancelledAt?: any | null;
    note?: string | null;
    recommendedMessage?: string | null;
  }>;
  bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
  items: Array<{
    __typename?: 'InvoiceItem';
    name: string;
    pricePerUnit: number;
    priceSum: number;
    quantity: number;
    unit?: string | null;
    priceWithoutVat?: number | null;
    vatRate?: string | null;
  }>;
};

export type ClaimDataEntriesFragmentFragment = {
  __typename?: 'Invoice';
  name?: string | null;
  number?: string | null;
  amountDue?: number | null;
  currency?: string | null;
  bankAccount?: string | null;
  bankNumber?: string | null;
  iban?: string | null;
  swift?: string | null;
  variableSymbol?: string | null;
  dueDate?: any | null;
  customer?: { __typename?: 'Customer'; name?: string | null } | null;
  vendor?: { __typename?: 'Vendor'; name?: string | null } | null;
};

export type CustomerFragmentFragment = {
  __typename?: 'Customer';
  id: string;
  name?: string | null;
  taxId?: string | null;
  vatId?: string | null;
  address?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  remindingTone: RemindingTone;
};

export type InvoiceFragmentFragment = {
  __typename?: 'Invoice';
  id: string;
  canBeArchived: boolean;
  number?: string | null;
  amount?: number | null;
  amountDue?: number | null;
  amountVat?: number | null;
  amountWithoutVat?: number | null;
  taxPayer: boolean;
  taxPoint?: any | null;
  settled: boolean;
  currency?: string | null;
  createdAt: any;
  bankAccount?: string | null;
  bankNumber?: string | null;
  iban?: string | null;
  swift?: string | null;
  annotationComplete: boolean;
  customerNote?: string | null;
  issueDate?: any | null;
  dueDate?: any | null;
  variableSymbol?: string | null;
  status: InvoiceStatus;
  plan?: Plan | null;
  planPaid: boolean;
  remindingTone: RemindingTone;
  isAnnotated: boolean;
  downloadUrl?: string | null;
  customer?: {
    __typename?: 'Customer';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    remindingTone: RemindingTone;
  } | null;
  vendor?: {
    __typename?: 'Vendor';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
  } | null;
  scheduledActions: Array<{
    __typename?: 'ScheduledAction';
    id: string;
    scheduledAt: any;
    action: Action;
    doneAt?: any | null;
    cancelledAt?: any | null;
    note?: string | null;
    recommendedMessage?: string | null;
  }>;
  bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
  items: Array<{
    __typename?: 'InvoiceItem';
    name: string;
    pricePerUnit: number;
    priceSum: number;
    quantity: number;
    unit?: string | null;
    priceWithoutVat?: number | null;
    vatRate?: string | null;
  }>;
};

export type InvoiceAdminFragmentFragment = {
  __typename?: 'Invoice';
  id: string;
  number?: string | null;
  amount?: number | null;
  amountDue?: number | null;
  settled: boolean;
  currency?: string | null;
  bankAccount?: string | null;
  createdAt: any;
  bankNumber?: string | null;
  annotationComplete: boolean;
  remindingTone: RemindingTone;
  customerNote?: string | null;
  iban?: string | null;
  swift?: string | null;
  issueDate?: any | null;
  dueDate?: any | null;
  variableSymbol?: string | null;
  status: InvoiceStatus;
  plan?: Plan | null;
  planPaid: boolean;
  customer?: {
    __typename?: 'Customer';
    id: string;
    vatId?: string | null;
    taxId?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    address?: string | null;
    name?: string | null;
    remindingTone: RemindingTone;
  } | null;
  vendor?: {
    __typename?: 'Vendor';
    id: string;
    name?: string | null;
    address?: string | null;
    taxId?: string | null;
    vatId?: string | null;
  } | null;
  owner: {
    __typename?: 'User';
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    phoneNumber?: string | null;
  };
  scheduledActions: Array<{
    __typename?: 'ScheduledAction';
    id: string;
    action: Action;
    scheduledAt: any;
    cancelledAt?: any | null;
    doneAt?: any | null;
    note?: string | null;
    internalNote?: string | null;
    recommendedSubject?: string | null;
    recommendedMessage?: string | null;
    success?: boolean | null;
    templateNoPayment?: string | null;
    templatePartialPayment?: string | null;
    invoiceId: string;
  }>;
};

export type ScenarioPlanFragmentFragment = {
  __typename?: 'ScenarioPlan';
  name: ScenarioPlanName;
  email: number;
  sms: number;
  call: number;
};

export type ReceivedMessageFragmentFragment = {
  __typename?: 'ReceivedMessage';
  id: string;
  kind: MessageKind;
  createdAt: any;
  receivedAt: any;
  text: string;
  from: string;
  to: string;
  relevantScheduledActions: Array<{
    __typename?: 'ScheduledAction';
    id: string;
    customerName?: string | null;
    vendorName?: string | null;
    invoiceId: string;
    invoiceNumber?: string | null;
    action: Action;
    doneAt?: any | null;
  }>;
};

export type ScenarioFragmentFragment = {
  __typename?: 'Scenario';
  id: string;
  static: boolean;
  name: string;
  textSms: Array<string>;
  textEmail: Array<string>;
  textCall: Array<string>;
  subject: Array<string>;
  plan: { __typename?: 'ScenarioPlan'; name: ScenarioPlanName; call: number; sms: number; email: number };
};

export type ScheduledActionFragmentFragment = {
  __typename?: 'ScheduledAction';
  id: string;
  scheduledAt: any;
  action: Action;
  doneAt?: any | null;
  cancelledAt?: any | null;
  note?: string | null;
  recommendedMessage?: string | null;
};

export type ScheduledActionAdminFragmentFragment = {
  __typename?: 'ScheduledAction';
  id: string;
  action: Action;
  scheduledAt: any;
  cancelledAt?: any | null;
  doneAt?: any | null;
  note?: string | null;
  internalNote?: string | null;
  recommendedSubject?: string | null;
  recommendedMessage?: string | null;
  success?: boolean | null;
  templateNoPayment?: string | null;
  templatePartialPayment?: string | null;
  invoiceId: string;
};

export type UserFragmentFragment = {
  __typename?: 'User';
  id: string;
  phoneNumber?: string | null;
  email: string;
  vatId?: string | null;
  taxId?: string | null;
  zipCode?: string | null;
  streetAddress?: string | null;
  country?: string | null;
  city?: string | null;
  businessName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  role: Role;
  plan: UserPlan;
  defaultRemindingTone: RemindingTone;
  bankAccount?: string | null;
  bankNumber?: string | null;
  swift?: string | null;
  iban?: string | null;
  remindersCount: number;
  remindersLimit?: number | null;
};

export type VendorFragmentFragment = {
  __typename?: 'Vendor';
  id: string;
  name?: string | null;
  taxId?: string | null;
  vatId?: string | null;
  address?: string | null;
};

export type ArchiveInvoicesMutationVariables = Exact<{
  invoiceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ArchiveInvoicesMutation = {
  __typename?: 'Mutation';
  archive: { __typename?: 'ArchiveResult'; failed: Array<string> };
};

export type AttachClaimsToBatchUploadMutationVariables = Exact<{
  input: AttachClaimsToBatchUploadInput;
}>;

export type AttachClaimsToBatchUploadMutation = {
  __typename?: 'Mutation';
  attachClaimsToBatchUpload: { __typename?: 'BatchUpload'; id: string; standardPrice?: number | null };
};

export type AttachInvoicesToBatchUploadMutationVariables = Exact<{
  input: AttachInvoicesToBatchUploadInput;
}>;

export type AttachInvoicesToBatchUploadMutation = {
  __typename?: 'Mutation';
  attachInvoicesToBatchUpload: { __typename?: 'BatchUpload'; id: string; standardPrice?: number | null };
};

export type ConfirmInvoiceMutationVariables = Exact<{
  input: ConfirmInvoiceInput;
}>;

export type ConfirmInvoiceMutation = {
  __typename?: 'Mutation';
  confirmInvoice: { __typename?: 'Invoice'; id: string };
};

export type ConnectBankMutationVariables = Exact<{
  input: AuthenticateBankInput;
}>;

export type ConnectBankMutation = {
  __typename?: 'Mutation';
  connectBank: { __typename?: 'BankAuthentication'; redirectUrl: string };
};

export type CreateBatchMutationVariables = Exact<{
  input: CreateBatchUploadInput;
}>;

export type CreateBatchMutation = {
  __typename?: 'Mutation';
  createBatchUpload: {
    __typename?: 'BatchUpload';
    id: string;
    plan?: Plan | null;
    invoicesCount: number;
    planPaid: boolean;
    standardPrice?: number | null;
    standardDiscount?: number | null;
    scenario?: {
      __typename?: 'Scenario';
      id: string;
      plan: { __typename?: 'ScenarioPlan'; name: ScenarioPlanName; email: number; sms: number; call: number };
    } | null;
  };
};

export type CreateBatchPaymentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  plan: Plan;
}>;

export type CreateBatchPaymentMutation = {
  __typename?: 'Mutation';
  createBatchPayment: { __typename?: 'PlanPayment'; clientSecret?: string | null; paymentRequired: boolean };
};

export type CreateCustomerMutationVariables = Exact<{
  customer: CustomerCreateInput;
}>;

export type CreateCustomerMutation = {
  __typename?: 'Mutation';
  createCustomer: {
    __typename?: 'Customer';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    remindingTone: RemindingTone;
  };
};

export type CreateInvoiceMutationVariables = Exact<{ [key: string]: never }>;

export type CreateInvoiceMutation = { __typename?: 'Mutation'; createInvoice: { __typename?: 'Invoice'; id: string } };

export type CreateInvoiceManuallyMutationVariables = Exact<{
  input: CreateInvoiceManuallyInput;
}>;

export type CreateInvoiceManuallyMutation = {
  __typename?: 'Mutation';
  createInvoiceManually: { __typename?: 'Invoice'; id: string };
};

export type CreateInvoicesFromJsonMutationVariables = Exact<{
  input: CreateInvoicesFromMappedDataInput;
}>;

export type CreateInvoicesFromJsonMutation = {
  __typename?: 'Mutation';
  createInvoicesFromJson: { __typename?: 'BatchUpload'; id: string };
};

export type CreatePaymentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  plan: Plan;
}>;

export type CreatePaymentMutation = {
  __typename?: 'Mutation';
  createPayment: { __typename?: 'PlanPayment'; clientSecret?: string | null; paymentRequired: boolean };
};

export type CreateScenarioMutationVariables = Exact<{
  input: ScenarioCreateInput;
}>;

export type CreateScenarioMutation = {
  __typename?: 'Mutation';
  createScenario: { __typename?: 'Scenario'; id: string };
};

export type CreateVendorMutationVariables = Exact<{
  vendor: VendorCreateInput;
}>;

export type CreateVendorMutation = {
  __typename?: 'Mutation';
  createVendor: {
    __typename?: 'Vendor';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
  };
};

export type DeleteScenarioMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteScenarioMutation = { __typename?: 'Mutation'; deleteScenario: string };

export type DenyUnsupportedFileContactConsentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DenyUnsupportedFileContactConsentMutation = {
  __typename?: 'Mutation';
  denyUnsupportedFileContactConsent?: { __typename?: 'SuccessResult'; success: boolean } | null;
};

export type DisconnectBankMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DisconnectBankMutation = { __typename?: 'Mutation'; disconnectBank: string };

export type EditInvoiceMutationVariables = Exact<{
  input: EditInvoiceInput;
}>;

export type EditInvoiceMutation = {
  __typename?: 'Mutation';
  editInvoice: {
    __typename?: 'Invoice';
    id: string;
    canBeArchived: boolean;
    number?: string | null;
    amount?: number | null;
    amountDue?: number | null;
    amountVat?: number | null;
    amountWithoutVat?: number | null;
    taxPayer: boolean;
    taxPoint?: any | null;
    settled: boolean;
    currency?: string | null;
    createdAt: any;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    annotationComplete: boolean;
    customerNote?: string | null;
    issueDate?: any | null;
    dueDate?: any | null;
    variableSymbol?: string | null;
    status: InvoiceStatus;
    plan?: Plan | null;
    planPaid: boolean;
    remindingTone: RemindingTone;
    isAnnotated: boolean;
    downloadUrl?: string | null;
    customer?: {
      __typename?: 'Customer';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      remindingTone: RemindingTone;
    } | null;
    vendor?: {
      __typename?: 'Vendor';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
    } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
    bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      priceWithoutVat?: number | null;
      vatRate?: string | null;
    }>;
  };
};

export type EndInvoiceRemindingMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;

export type EndInvoiceRemindingMutation = {
  __typename?: 'Mutation';
  endReminding: {
    __typename?: 'Invoice';
    id: string;
    canBeArchived: boolean;
    number?: string | null;
    amount?: number | null;
    amountDue?: number | null;
    amountVat?: number | null;
    amountWithoutVat?: number | null;
    taxPayer: boolean;
    taxPoint?: any | null;
    settled: boolean;
    currency?: string | null;
    createdAt: any;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    annotationComplete: boolean;
    customerNote?: string | null;
    issueDate?: any | null;
    dueDate?: any | null;
    variableSymbol?: string | null;
    status: InvoiceStatus;
    plan?: Plan | null;
    planPaid: boolean;
    remindingTone: RemindingTone;
    isAnnotated: boolean;
    downloadUrl?: string | null;
    customer?: {
      __typename?: 'Customer';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      remindingTone: RemindingTone;
    } | null;
    vendor?: {
      __typename?: 'Vendor';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
    } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
    bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      priceWithoutVat?: number | null;
      vatRate?: string | null;
    }>;
  };
};

export type EscalateUnpaidInvoiceMutationVariables = Exact<{
  input: EscalateUnpaidInvoiceInput;
}>;

export type EscalateUnpaidInvoiceMutation = { __typename?: 'Mutation'; escalateUnpaidInvoice: boolean };

export type RequestNewPlanMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;

export type RequestNewPlanMutation = {
  __typename?: 'Mutation';
  requestNewPlan: {
    __typename?: 'Invoice';
    id: string;
    canBeArchived: boolean;
    number?: string | null;
    amount?: number | null;
    amountDue?: number | null;
    amountVat?: number | null;
    amountWithoutVat?: number | null;
    taxPayer: boolean;
    taxPoint?: any | null;
    settled: boolean;
    currency?: string | null;
    createdAt: any;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    annotationComplete: boolean;
    customerNote?: string | null;
    issueDate?: any | null;
    dueDate?: any | null;
    variableSymbol?: string | null;
    status: InvoiceStatus;
    plan?: Plan | null;
    planPaid: boolean;
    remindingTone: RemindingTone;
    isAnnotated: boolean;
    downloadUrl?: string | null;
    customer?: {
      __typename?: 'Customer';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      remindingTone: RemindingTone;
    } | null;
    vendor?: {
      __typename?: 'Vendor';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
    } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
    bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      priceWithoutVat?: number | null;
      vatRate?: string | null;
    }>;
  };
};

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never }>;

export type ResendVerificationEmailMutation = { __typename?: 'Mutation'; resendVerificationEmail: boolean };

export type UpdateAdminUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  input: AdminUserInput;
}>;

export type UpdateAdminUserMutation = {
  __typename?: 'Mutation';
  updateAdminUser: {
    __typename?: 'User';
    id: string;
    phoneNumber?: string | null;
    email: string;
    vatId?: string | null;
    taxId?: string | null;
    zipCode?: string | null;
    streetAddress?: string | null;
    country?: string | null;
    city?: string | null;
    businessName?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    role: Role;
    plan: UserPlan;
    defaultRemindingTone: RemindingTone;
    bankAccount?: string | null;
    bankNumber?: string | null;
    swift?: string | null;
    iban?: string | null;
    remindersCount: number;
    remindersLimit?: number | null;
  };
};

export type UpdateCustomerMutationVariables = Exact<{
  customer: CustomerUpdateInput;
}>;

export type UpdateCustomerMutation = {
  __typename?: 'Mutation';
  updateCustomer: {
    __typename?: 'Customer';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    remindingTone: RemindingTone;
  };
};

export type UpdateInvoiceAmountDueMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  amountDue: Scalars['Float']['input'];
}>;

export type UpdateInvoiceAmountDueMutation = {
  __typename?: 'Mutation';
  setDueAmount: {
    __typename?: 'Invoice';
    id: string;
    canBeArchived: boolean;
    number?: string | null;
    amount?: number | null;
    amountDue?: number | null;
    amountVat?: number | null;
    amountWithoutVat?: number | null;
    taxPayer: boolean;
    taxPoint?: any | null;
    settled: boolean;
    currency?: string | null;
    createdAt: any;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    annotationComplete: boolean;
    customerNote?: string | null;
    issueDate?: any | null;
    dueDate?: any | null;
    variableSymbol?: string | null;
    status: InvoiceStatus;
    plan?: Plan | null;
    planPaid: boolean;
    remindingTone: RemindingTone;
    isAnnotated: boolean;
    downloadUrl?: string | null;
    customer?: {
      __typename?: 'Customer';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      remindingTone: RemindingTone;
    } | null;
    vendor?: {
      __typename?: 'Vendor';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
    } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
    bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      priceWithoutVat?: number | null;
      vatRate?: string | null;
    }>;
  };
};

export type UpdateScenarioMutationVariables = Exact<{
  input: ScenarioUpdateInput;
}>;

export type UpdateScenarioMutation = {
  __typename?: 'Mutation';
  updateScenario: { __typename?: 'Scenario'; id: string };
};

export type UpdateScheduledActionMutationVariables = Exact<{
  input: ScheduledActionUpdateInput;
}>;

export type UpdateScheduledActionMutation = {
  __typename?: 'Mutation';
  updateScheduledAction: {
    __typename?: 'ScheduledAction';
    id: string;
    action: Action;
    scheduledAt: any;
    cancelledAt?: any | null;
    doneAt?: any | null;
    note?: string | null;
    internalNote?: string | null;
    recommendedSubject?: string | null;
    recommendedMessage?: string | null;
    success?: boolean | null;
    templateNoPayment?: string | null;
    templatePartialPayment?: string | null;
    invoiceId: string;
  };
};

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    phoneNumber?: string | null;
    email: string;
    vatId?: string | null;
    taxId?: string | null;
    zipCode?: string | null;
    streetAddress?: string | null;
    country?: string | null;
    city?: string | null;
    businessName?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    role: Role;
    plan: UserPlan;
    defaultRemindingTone: RemindingTone;
    bankAccount?: string | null;
    bankNumber?: string | null;
    swift?: string | null;
    iban?: string | null;
    remindersCount: number;
    remindersLimit?: number | null;
  };
};

export type UpdateVendorMutationVariables = Exact<{
  vendor: VendorUpdateInput;
}>;

export type UpdateVendorMutation = {
  __typename?: 'Mutation';
  updateVendor: {
    __typename?: 'Vendor';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
  };
};

export type AdminClaimQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AdminClaimQuery = {
  __typename?: 'Query';
  adminInvoice: {
    __typename?: 'Invoice';
    id: string;
    name?: string | null;
    canBeArchived: boolean;
    number?: string | null;
    amount?: number | null;
    amountDue?: number | null;
    amountVat?: number | null;
    amountWithoutVat?: number | null;
    taxPayer: boolean;
    taxPoint?: any | null;
    settled: boolean;
    currency?: string | null;
    createdAt: any;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    annotationComplete: boolean;
    customerNote?: string | null;
    issueDate?: any | null;
    dueDate?: any | null;
    variableSymbol?: string | null;
    status: InvoiceStatus;
    plan?: Plan | null;
    planPaid: boolean;
    remindingTone: RemindingTone;
    isAnnotated: boolean;
    downloadUrl?: string | null;
    scenario?: { __typename?: 'Scenario'; id: string } | null;
    customer?: {
      __typename?: 'Customer';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      remindingTone: RemindingTone;
    } | null;
    vendor?: {
      __typename?: 'Vendor';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
    } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
    bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      priceWithoutVat?: number | null;
      vatRate?: string | null;
    }>;
  };
};

export type AdminClaimDataEntriesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AdminClaimDataEntriesQuery = {
  __typename?: 'Query';
  adminInvoice: {
    __typename?: 'Invoice';
    name?: string | null;
    number?: string | null;
    amountDue?: number | null;
    currency?: string | null;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    variableSymbol?: string | null;
    dueDate?: any | null;
    customer?: { __typename?: 'Customer'; name?: string | null } | null;
    vendor?: { __typename?: 'Vendor'; name?: string | null } | null;
  };
};

export type AdminClaimIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AdminClaimIdQuery = { __typename?: 'Query'; adminInvoice: { __typename?: 'Invoice'; id: string } };

export type AdminClaimScheduledActionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AdminClaimScheduledActionsQuery = {
  __typename?: 'Query';
  adminInvoice: {
    __typename?: 'Invoice';
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
  };
};

export type AdminClaimsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;

export type AdminClaimsQuery = {
  __typename?: 'Query';
  adminInvoices: {
    __typename?: 'AdminInvoices';
    totalCount: number;
    results: Array<{
      __typename?: 'Invoice';
      id: string;
      name?: string | null;
      createdAt: any;
      issueDate?: any | null;
      number?: string | null;
      amountDue?: number | null;
      status: InvoiceStatus;
      scenario?: { __typename?: 'Scenario'; name: string } | null;
      customer?: { __typename?: 'Customer'; id: string; name?: string | null } | null;
      owner: { __typename?: 'User'; id: string; firstName?: string | null; lastName?: string | null };
    }>;
  };
};

export type AdminInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AdminInvoiceQuery = {
  __typename?: 'Query';
  adminInvoice: {
    __typename?: 'Invoice';
    id: string;
    number?: string | null;
    amount?: number | null;
    amountDue?: number | null;
    settled: boolean;
    currency?: string | null;
    bankAccount?: string | null;
    createdAt: any;
    bankNumber?: string | null;
    annotationComplete: boolean;
    remindingTone: RemindingTone;
    customerNote?: string | null;
    iban?: string | null;
    swift?: string | null;
    issueDate?: any | null;
    dueDate?: any | null;
    variableSymbol?: string | null;
    status: InvoiceStatus;
    plan?: Plan | null;
    planPaid: boolean;
    customer?: {
      __typename?: 'Customer';
      id: string;
      vatId?: string | null;
      taxId?: string | null;
      phoneNumber?: string | null;
      email?: string | null;
      address?: string | null;
      name?: string | null;
      remindingTone: RemindingTone;
    } | null;
    vendor?: {
      __typename?: 'Vendor';
      id: string;
      name?: string | null;
      address?: string | null;
      taxId?: string | null;
      vatId?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      firstName?: string | null;
      lastName?: string | null;
      email: string;
      phoneNumber?: string | null;
    };
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      action: Action;
      scheduledAt: any;
      cancelledAt?: any | null;
      doneAt?: any | null;
      note?: string | null;
      internalNote?: string | null;
      recommendedSubject?: string | null;
      recommendedMessage?: string | null;
      success?: boolean | null;
      templateNoPayment?: string | null;
      templatePartialPayment?: string | null;
      invoiceId: string;
    }>;
  };
};

export type AdminInvoiceNumberQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AdminInvoiceNumberQuery = {
  __typename?: 'Query';
  adminInvoice: { __typename?: 'Invoice'; number?: string | null };
};

export type AdminInvoicesQueryVariables = Exact<{
  query: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;

export type AdminInvoicesQuery = {
  __typename?: 'Query';
  adminInvoices: {
    __typename?: 'AdminInvoices';
    totalCount: number;
    results: Array<{
      __typename?: 'Invoice';
      id: string;
      createdAt: any;
      issueDate?: any | null;
      number?: string | null;
      status: InvoiceStatus;
      remindingTone: RemindingTone;
      amountDue?: number | null;
      vendor?: { __typename?: 'Vendor'; id: string; name?: string | null } | null;
      customer?: { __typename?: 'Customer'; id: string; name?: string | null } | null;
      owner: { __typename?: 'User'; id: string; firstName?: string | null; lastName?: string | null };
    }>;
  };
};

export type AdminModelsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminModelsQuery = {
  __typename?: 'Query';
  invoiceModels: Array<{
    __typename?: 'InvoiceModel';
    id: string;
    name: string;
    fields: Array<{ __typename?: 'InvoiceModelField'; name: ModelFieldName; required: boolean }>;
  }>;
};

export type AdminScenarioQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AdminScenarioQuery = {
  __typename?: 'Query';
  adminScenario: {
    __typename?: 'Scenario';
    id: string;
    static: boolean;
    name: string;
    textSms: Array<string>;
    textEmail: Array<string>;
    textCall: Array<string>;
    subject: Array<string>;
    model: {
      __typename?: 'InvoiceModel';
      id: string;
      name: string;
      fields: Array<{ __typename?: 'InvoiceModelField'; name: ModelFieldName; required: boolean }>;
    };
    user?: {
      __typename?: 'User';
      id: string;
      phoneNumber?: string | null;
      email: string;
      vatId?: string | null;
      taxId?: string | null;
      zipCode?: string | null;
      streetAddress?: string | null;
      country?: string | null;
      city?: string | null;
      businessName?: string | null;
      lastName?: string | null;
      firstName?: string | null;
      role: Role;
      plan: UserPlan;
      defaultRemindingTone: RemindingTone;
      bankAccount?: string | null;
      bankNumber?: string | null;
      swift?: string | null;
      iban?: string | null;
      remindersCount: number;
      remindersLimit?: number | null;
    } | null;
    plan: { __typename?: 'ScenarioPlan'; name: ScenarioPlanName; call: number; sms: number; email: number };
  };
};

export type AdminScenarioPlansQueryVariables = Exact<{ [key: string]: never }>;

export type AdminScenarioPlansQuery = {
  __typename?: 'Query';
  scenarioPlans: Array<{
    __typename?: 'ScenarioPlan';
    name: ScenarioPlanName;
    email: number;
    sms: number;
    call: number;
  }>;
};

export type AdminScenariosQueryVariables = Exact<{
  query: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;

export type AdminScenariosQuery = {
  __typename?: 'Query';
  adminScenarios: {
    __typename?: 'AdminScenarios';
    totalCount: number;
    results: Array<{
      __typename?: 'Scenario';
      id: string;
      name: string;
      static: boolean;
      user?: { __typename?: 'User'; id: string; firstName?: string | null; lastName?: string | null } | null;
      model: { __typename?: 'InvoiceModel'; id: string; name: string };
      plan: { __typename?: 'ScenarioPlan'; name: ScenarioPlanName; email: number; sms: number; call: number };
    }>;
  };
};

export type AdminUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;

export type AdminUsersQuery = {
  __typename?: 'Query';
  adminUsers: {
    __typename?: 'AdminUsers';
    totalCount: number;
    results: Array<{
      __typename?: 'User';
      id: string;
      phoneNumber?: string | null;
      email: string;
      vatId?: string | null;
      taxId?: string | null;
      zipCode?: string | null;
      streetAddress?: string | null;
      country?: string | null;
      city?: string | null;
      businessName?: string | null;
      lastName?: string | null;
      firstName?: string | null;
      role: Role;
      plan: UserPlan;
      defaultRemindingTone: RemindingTone;
      bankAccount?: string | null;
      bankNumber?: string | null;
      swift?: string | null;
      iban?: string | null;
      remindersCount: number;
      remindersLimit?: number | null;
    }>;
  };
};

export type GetAresDataQueryVariables = Exact<{
  vatId: Scalars['String']['input'];
}>;

export type GetAresDataQuery = {
  __typename?: 'Query';
  queryAres?: {
    __typename?: 'AresResult';
    vatId?: string | null;
    taxId?: string | null;
    name?: string | null;
    streetAddress?: string | null;
    city?: string | null;
    country?: string | null;
    zip?: string | null;
  } | null;
};

export type AuthStatusQueryVariables = Exact<{ [key: string]: never }>;

export type AuthStatusQuery = { __typename?: 'Query'; authStatus: string };

export type BankConnectionsQueryVariables = Exact<{ [key: string]: never }>;

export type BankConnectionsQuery = {
  __typename?: 'Query';
  bankConnections: Array<{
    __typename?: 'BankConnection';
    id: string;
    provider: string;
    status: BankConnectionStatus;
    bankLogoUrl?: string | null;
    bankName?: string | null;
  }>;
};

export type BatchUploadQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type BatchUploadQuery = {
  __typename?: 'Query';
  batchUpload: {
    __typename?: 'BatchUpload';
    id: string;
    plan?: Plan | null;
    invoicesCount: number;
    planPaid: boolean;
    standardPrice?: number | null;
    standardDiscount?: number | null;
    scenario?: {
      __typename?: 'Scenario';
      id: string;
      plan: { __typename?: 'ScenarioPlan'; name: ScenarioPlanName; email: number; sms: number; call: number };
    } | null;
  };
};

export type BatchUploadStatusQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type BatchUploadStatusQuery = {
  __typename?: 'Query';
  batchUpload: {
    __typename?: 'BatchUpload';
    id: string;
    invoices: Array<{
      __typename?: 'Invoice';
      id: string;
      status: InvoiceStatus;
      number?: string | null;
      createdAt: any;
    }>;
  };
};

export type ClaimQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ClaimQuery = {
  __typename?: 'Query';
  invoice: {
    __typename?: 'Invoice';
    id: string;
    name?: string | null;
    canBeArchived: boolean;
    number?: string | null;
    amount?: number | null;
    amountDue?: number | null;
    amountVat?: number | null;
    amountWithoutVat?: number | null;
    taxPayer: boolean;
    taxPoint?: any | null;
    settled: boolean;
    currency?: string | null;
    createdAt: any;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    annotationComplete: boolean;
    customerNote?: string | null;
    issueDate?: any | null;
    dueDate?: any | null;
    variableSymbol?: string | null;
    status: InvoiceStatus;
    plan?: Plan | null;
    planPaid: boolean;
    remindingTone: RemindingTone;
    isAnnotated: boolean;
    downloadUrl?: string | null;
    scenario?: { __typename?: 'Scenario'; id: string } | null;
    customer?: {
      __typename?: 'Customer';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      remindingTone: RemindingTone;
    } | null;
    vendor?: {
      __typename?: 'Vendor';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
    } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
    bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      priceWithoutVat?: number | null;
      vatRate?: string | null;
    }>;
  };
};

export type ClaimDataEntriesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ClaimDataEntriesQuery = {
  __typename?: 'Query';
  invoice: {
    __typename?: 'Invoice';
    name?: string | null;
    number?: string | null;
    amountDue?: number | null;
    currency?: string | null;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    variableSymbol?: string | null;
    dueDate?: any | null;
    customer?: { __typename?: 'Customer'; name?: string | null } | null;
    vendor?: { __typename?: 'Vendor'; name?: string | null } | null;
  };
};

export type ClaimScheduledActionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ClaimScheduledActionsQuery = {
  __typename?: 'Query';
  invoice: {
    __typename?: 'Invoice';
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
  };
};

export type ClaimsQueryVariables = Exact<{ [key: string]: never }>;

export type ClaimsQuery = {
  __typename?: 'Query';
  invoices: Array<{
    __typename?: 'Invoice';
    id: string;
    name?: string | null;
    number?: string | null;
    amountDue?: number | null;
    createdAt: any;
    plan?: Plan | null;
    planPaid: boolean;
    settled: boolean;
    status: InvoiceStatus;
    currency?: string | null;
    annotationComplete: boolean;
    isAnnotated: boolean;
    canBeArchived: boolean;
    customer?: { __typename?: 'Customer'; name?: string | null } | null;
    vendor?: { __typename?: 'Vendor'; name?: string | null } | null;
    batchUpload?: { __typename?: 'BatchUpload'; id: string; planPaid: boolean; type: BatchUploadType } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      doneAt?: any | null;
      action: Action;
    }>;
  }>;
};

export type CustomerQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type CustomerQuery = {
  __typename?: 'Query';
  customer: {
    __typename?: 'Customer';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    remindingTone: RemindingTone;
  };
};

export type CustomersQueryVariables = Exact<{ [key: string]: never }>;

export type CustomersQuery = {
  __typename?: 'Query';
  customers: Array<{
    __typename?: 'Customer';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    remindingTone: RemindingTone;
  }>;
};

export type InvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type InvoiceQuery = {
  __typename?: 'Query';
  invoice: {
    __typename?: 'Invoice';
    id: string;
    canBeArchived: boolean;
    number?: string | null;
    amount?: number | null;
    amountDue?: number | null;
    amountVat?: number | null;
    amountWithoutVat?: number | null;
    taxPayer: boolean;
    taxPoint?: any | null;
    settled: boolean;
    currency?: string | null;
    createdAt: any;
    bankAccount?: string | null;
    bankNumber?: string | null;
    iban?: string | null;
    swift?: string | null;
    annotationComplete: boolean;
    customerNote?: string | null;
    issueDate?: any | null;
    dueDate?: any | null;
    variableSymbol?: string | null;
    status: InvoiceStatus;
    plan?: Plan | null;
    planPaid: boolean;
    remindingTone: RemindingTone;
    isAnnotated: boolean;
    downloadUrl?: string | null;
    customer?: {
      __typename?: 'Customer';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      remindingTone: RemindingTone;
    } | null;
    vendor?: {
      __typename?: 'Vendor';
      id: string;
      name?: string | null;
      taxId?: string | null;
      vatId?: string | null;
      address?: string | null;
    } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      action: Action;
      doneAt?: any | null;
      cancelledAt?: any | null;
      note?: string | null;
      recommendedMessage?: string | null;
    }>;
    bankTransactions: Array<{ __typename?: 'BankTransaction'; id: string }>;
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      priceWithoutVat?: number | null;
      vatRate?: string | null;
    }>;
  };
};

export type InvoicePlanPriceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type InvoicePlanPriceQuery = {
  __typename?: 'Query';
  invoice: {
    __typename?: 'Invoice';
    id: string;
    standardPrice?: number | null;
    standardDiscount?: number | null;
    trialPrice?: number | null;
    trialDiscount?: number | null;
    customer?: { __typename?: 'Customer'; id: string; phoneNumber?: string | null; email?: string | null } | null;
  };
};

export type InvoiceStatusQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type InvoiceStatusQuery = {
  __typename?: 'Query';
  invoice: {
    __typename?: 'Invoice';
    id: string;
    status: InvoiceStatus;
    isAnnotated: boolean;
    batchUpload?: { __typename?: 'BatchUpload'; id: string; planPaid: boolean; type: BatchUploadType } | null;
  };
};

export type InvoicesQueryVariables = Exact<{ [key: string]: never }>;

export type InvoicesQuery = {
  __typename?: 'Query';
  invoices: Array<{
    __typename?: 'Invoice';
    id: string;
    number?: string | null;
    amountDue?: number | null;
    createdAt: any;
    issueDate?: any | null;
    plan?: Plan | null;
    planPaid: boolean;
    settled: boolean;
    status: InvoiceStatus;
    currency?: string | null;
    annotationComplete: boolean;
    isAnnotated: boolean;
    canBeArchived: boolean;
    customer?: { __typename?: 'Customer'; name?: string | null } | null;
    vendor?: { __typename?: 'Vendor'; name?: string | null } | null;
    batchUpload?: { __typename?: 'BatchUpload'; id: string; planPaid: boolean; type: BatchUploadType } | null;
    scheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      scheduledAt: any;
      doneAt?: any | null;
      action: Action;
    }>;
  }>;
};

export type ReceivedMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type ReceivedMessagesQuery = {
  __typename?: 'Query';
  receivedMessages: Array<{
    __typename?: 'ReceivedMessage';
    id: string;
    kind: MessageKind;
    createdAt: any;
    receivedAt: any;
    text: string;
    from: string;
    to: string;
    relevantScheduledActions: Array<{
      __typename?: 'ScheduledAction';
      id: string;
      customerName?: string | null;
      vendorName?: string | null;
      invoiceId: string;
      invoiceNumber?: string | null;
      action: Action;
      doneAt?: any | null;
    }>;
  }>;
};

export type ScenarioQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ScenarioQuery = {
  __typename?: 'Query';
  scenario: {
    __typename?: 'Scenario';
    id: string;
    static: boolean;
    name: string;
    textSms: Array<string>;
    textEmail: Array<string>;
    textCall: Array<string>;
    subject: Array<string>;
    plan: { __typename?: 'ScenarioPlan'; name: ScenarioPlanName; call: number; sms: number; email: number };
  };
};

export type ScenariosQueryVariables = Exact<{ [key: string]: never }>;

export type ScenariosQuery = {
  __typename?: 'Query';
  scenarios: Array<{
    __typename?: 'Scenario';
    id: string;
    static: boolean;
    name: string;
    textSms: Array<string>;
    textEmail: Array<string>;
    textCall: Array<string>;
    subject: Array<string>;
    plan: { __typename?: 'ScenarioPlan'; name: ScenarioPlanName; call: number; sms: number; email: number };
  }>;
};

export type ScheduledActionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ScheduledActionQuery = {
  __typename?: 'Query';
  scheduledAction: {
    __typename?: 'ScheduledAction';
    id: string;
    action: Action;
    scheduledAt: any;
    cancelledAt?: any | null;
    doneAt?: any | null;
    note?: string | null;
    internalNote?: string | null;
    recommendedSubject?: string | null;
    recommendedMessage?: string | null;
    success?: boolean | null;
    templateNoPayment?: string | null;
    templatePartialPayment?: string | null;
    invoiceId: string;
  };
};

export type ScheduledActionTitleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ScheduledActionTitleQuery = {
  __typename?: 'Query';
  scheduledAction: {
    __typename?: 'ScheduledAction';
    id: string;
    action: Action;
    vendorName?: string | null;
    customerName?: string | null;
    invoiceClaim: boolean;
  };
};

export type ScheduledActionsForTodayQueryVariables = Exact<{ [key: string]: never }>;

export type ScheduledActionsForTodayQuery = {
  __typename?: 'Query';
  scheduledActionsForToday: Array<{
    __typename?: 'ScheduledAction';
    id: string;
    scheduledAt: any;
    doneAt?: any | null;
    action: Action;
    success?: boolean | null;
    customerName?: string | null;
    vendorName?: string | null;
    invoiceId: string;
    invoiceNumber?: string | null;
    invoiceClaim: boolean;
  }>;
};

export type ScheduledActionsDoneTodayQueryVariables = Exact<{ [key: string]: never }>;

export type ScheduledActionsDoneTodayQuery = {
  __typename?: 'Query';
  scheduledActionsDoneToday: Array<{
    __typename?: 'ScheduledAction';
    id: string;
    scheduledAt: any;
    doneAt?: any | null;
    action: Action;
    success?: boolean | null;
    customerName?: string | null;
    vendorName?: string | null;
    invoiceNumber?: string | null;
    invoiceId: string;
    invoiceClaim: boolean;
  }>;
};

export type ScheduledActionInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ScheduledActionInvoiceQuery = {
  __typename?: 'Query';
  scheduledAction: {
    __typename?: 'ScheduledAction';
    id: string;
    invoice: {
      __typename?: 'Invoice';
      id: string;
      number?: string | null;
      amount?: number | null;
      amountDue?: number | null;
      settled: boolean;
      currency?: string | null;
      bankAccount?: string | null;
      createdAt: any;
      bankNumber?: string | null;
      annotationComplete: boolean;
      remindingTone: RemindingTone;
      customerNote?: string | null;
      iban?: string | null;
      swift?: string | null;
      issueDate?: any | null;
      dueDate?: any | null;
      variableSymbol?: string | null;
      status: InvoiceStatus;
      plan?: Plan | null;
      planPaid: boolean;
      customer?: {
        __typename?: 'Customer';
        id: string;
        vatId?: string | null;
        taxId?: string | null;
        phoneNumber?: string | null;
        email?: string | null;
        address?: string | null;
        name?: string | null;
        remindingTone: RemindingTone;
      } | null;
      vendor?: {
        __typename?: 'Vendor';
        id: string;
        name?: string | null;
        address?: string | null;
        taxId?: string | null;
        vatId?: string | null;
      } | null;
      owner: {
        __typename?: 'User';
        firstName?: string | null;
        lastName?: string | null;
        email: string;
        phoneNumber?: string | null;
      };
      scheduledActions: Array<{
        __typename?: 'ScheduledAction';
        id: string;
        action: Action;
        scheduledAt: any;
        cancelledAt?: any | null;
        doneAt?: any | null;
        note?: string | null;
        internalNote?: string | null;
        recommendedSubject?: string | null;
        recommendedMessage?: string | null;
        success?: boolean | null;
        templateNoPayment?: string | null;
        templatePartialPayment?: string | null;
        invoiceId: string;
      }>;
    };
  };
};

export type ScheduledActionInvoiceClaimQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ScheduledActionInvoiceClaimQuery = {
  __typename?: 'Query';
  scheduledAction: { __typename?: 'ScheduledAction'; id: string; invoiceClaim: boolean; invoiceId: string };
};

export type SupportedBanksQueryVariables = Exact<{ [key: string]: never }>;

export type SupportedBanksQuery = {
  __typename?: 'Query';
  supportedBanks: Array<{ __typename?: 'Bank'; name: string; logoUrl: string; paymentProvider: string }>;
};

export type UserQueryVariables = Exact<{ [key: string]: never }>;

export type UserQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    phoneNumber?: string | null;
    email: string;
    vatId?: string | null;
    taxId?: string | null;
    zipCode?: string | null;
    streetAddress?: string | null;
    country?: string | null;
    city?: string | null;
    businessName?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    role: Role;
    plan: UserPlan;
    defaultRemindingTone: RemindingTone;
    bankAccount?: string | null;
    bankNumber?: string | null;
    swift?: string | null;
    iban?: string | null;
    remindersCount: number;
    remindersLimit?: number | null;
  };
};

export type VendorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type VendorQuery = {
  __typename?: 'Query';
  vendor: {
    __typename?: 'Vendor';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
  };
};

export type VendorsQueryVariables = Exact<{ [key: string]: never }>;

export type VendorsQuery = {
  __typename?: 'Query';
  vendors: Array<{
    __typename?: 'Vendor';
    id: string;
    name?: string | null;
    taxId?: string | null;
    vatId?: string | null;
    address?: string | null;
  }>;
};

export const ScenarioPlanFragmentFragmentDoc = `
    fragment ScenarioPlanFragment on ScenarioPlan {
  name
  email
  sms
  call
}
    `;
export const BatchUploadFragmentDoc = `
    fragment BatchUpload on BatchUpload {
  id
  plan
  invoicesCount
  scenario {
    id
    plan {
      ...ScenarioPlanFragment
    }
  }
  standardPrice: price(plan: STANDARD)
  standardDiscount: discount(plan: STANDARD)
  planPaid
}
    ${ScenarioPlanFragmentFragmentDoc}`;
export const BatchUploadStatusFragmentDoc = `
    fragment BatchUploadStatus on BatchUpload {
  id
  invoices {
    id
    status
    number
    createdAt
  }
}
    `;
export const CustomerFragmentFragmentDoc = `
    fragment CustomerFragment on Customer {
  id
  name
  taxId
  vatId
  address
  email
  phoneNumber
  remindingTone
}
    `;
export const VendorFragmentFragmentDoc = `
    fragment VendorFragment on Vendor {
  id
  name
  taxId
  vatId
  address
}
    `;
export const ScheduledActionFragmentFragmentDoc = `
    fragment ScheduledActionFragment on ScheduledAction {
  id
  scheduledAt
  action
  doneAt
  cancelledAt
  note
  recommendedMessage
}
    `;
export const InvoiceFragmentFragmentDoc = `
    fragment InvoiceFragment on Invoice {
  id
  canBeArchived
  number
  amount
  amountDue
  amountVat
  amountWithoutVat
  taxPayer
  taxPoint
  settled
  currency
  createdAt
  bankAccount
  bankNumber
  iban
  swift
  annotationComplete
  customer {
    ...CustomerFragment
  }
  vendor {
    ...VendorFragment
  }
  customerNote
  issueDate
  dueDate
  variableSymbol
  status
  plan
  planPaid
  remindingTone
  scheduledActions {
    ...ScheduledActionFragment
  }
  isAnnotated
  bankTransactions {
    id
  }
  items {
    name
    pricePerUnit
    priceSum
    quantity
    unit
    priceWithoutVat
    vatRate
  }
  downloadUrl
}
    ${CustomerFragmentFragmentDoc}
${VendorFragmentFragmentDoc}
${ScheduledActionFragmentFragmentDoc}`;
export const ClaimFragmentFragmentDoc = `
    fragment ClaimFragment on Invoice {
  id
  name
  scenario {
    id
  }
  ...InvoiceFragment
}
    ${InvoiceFragmentFragmentDoc}`;
export const ClaimDataEntriesFragmentFragmentDoc = `
    fragment ClaimDataEntriesFragment on Invoice {
  name
  number
  amountDue
  currency
  bankAccount
  bankNumber
  customer {
    name
  }
  vendor {
    name
  }
  iban
  swift
  variableSymbol
  dueDate
}
    `;
export const ScheduledActionAdminFragmentFragmentDoc = `
    fragment ScheduledActionAdminFragment on ScheduledAction {
  id
  action
  scheduledAt
  cancelledAt
  doneAt
  note
  internalNote
  recommendedSubject
  recommendedMessage
  success
  templateNoPayment
  templatePartialPayment
  invoiceId
}
    `;
export const InvoiceAdminFragmentFragmentDoc = `
    fragment InvoiceAdminFragment on Invoice {
  id
  number
  amount
  amountDue
  settled
  currency
  bankAccount
  createdAt
  bankNumber
  annotationComplete
  remindingTone
  customer {
    id
    vatId
    taxId
    phoneNumber
    email
    address
    name
    remindingTone
  }
  vendor {
    id
    name
    address
    taxId
    vatId
  }
  owner {
    firstName
    lastName
    email
    phoneNumber
  }
  customerNote
  iban
  swift
  issueDate
  dueDate
  variableSymbol
  status
  plan
  planPaid
  scheduledActions {
    ...ScheduledActionAdminFragment
  }
}
    ${ScheduledActionAdminFragmentFragmentDoc}`;
export const ReceivedMessageFragmentFragmentDoc = `
    fragment ReceivedMessageFragment on ReceivedMessage {
  id
  kind
  createdAt
  receivedAt
  text
  from
  to
  relevantScheduledActions {
    id
    customerName
    vendorName
    invoiceId
    invoiceNumber
    action
    doneAt
  }
}
    `;
export const ScenarioFragmentFragmentDoc = `
    fragment ScenarioFragment on Scenario {
  id
  static
  name
  textSms
  textEmail
  textCall
  subject
  plan {
    name
    call
    sms
    email
  }
}
    `;
export const UserFragmentFragmentDoc = `
    fragment UserFragment on User {
  id
  phoneNumber
  email
  vatId
  taxId
  zipCode
  streetAddress
  country
  city
  businessName
  lastName
  firstName
  role
  plan
  defaultRemindingTone
  bankAccount
  bankNumber
  swift
  iban
  remindersCount
  remindersLimit
}
    `;
export const ArchiveInvoicesDocument = `
    mutation archiveInvoices($invoiceIds: [String!]!) {
  archive(invoiceIds: $invoiceIds) {
    failed
  }
}
    `;

export const useArchiveInvoicesMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<ArchiveInvoicesMutation, TError, ArchiveInvoicesMutationVariables, TContext>,
) => {
  return useMutation<ArchiveInvoicesMutation, TError, ArchiveInvoicesMutationVariables, TContext>({
    mutationKey: ['archiveInvoices'],
    mutationFn: useFetcher<ArchiveInvoicesMutation, ArchiveInvoicesMutationVariables>(ArchiveInvoicesDocument),
    ...options,
  });
};

export const AttachClaimsToBatchUploadDocument = `
    mutation AttachClaimsToBatchUpload($input: AttachClaimsToBatchUploadInput!) {
  attachClaimsToBatchUpload(input: $input) {
    id
    standardPrice: price(plan: STANDARD)
  }
}
    `;

export const useAttachClaimsToBatchUploadMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<
    AttachClaimsToBatchUploadMutation,
    TError,
    AttachClaimsToBatchUploadMutationVariables,
    TContext
  >,
) => {
  return useMutation<AttachClaimsToBatchUploadMutation, TError, AttachClaimsToBatchUploadMutationVariables, TContext>({
    mutationKey: ['AttachClaimsToBatchUpload'],
    mutationFn: useFetcher<AttachClaimsToBatchUploadMutation, AttachClaimsToBatchUploadMutationVariables>(
      AttachClaimsToBatchUploadDocument,
    ),
    ...options,
  });
};

export const AttachInvoicesToBatchUploadDocument = `
    mutation AttachInvoicesToBatchUpload($input: AttachInvoicesToBatchUploadInput!) {
  attachInvoicesToBatchUpload(input: $input) {
    id
    standardPrice: price(plan: STANDARD)
  }
}
    `;

export const useAttachInvoicesToBatchUploadMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<
    AttachInvoicesToBatchUploadMutation,
    TError,
    AttachInvoicesToBatchUploadMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AttachInvoicesToBatchUploadMutation,
    TError,
    AttachInvoicesToBatchUploadMutationVariables,
    TContext
  >({
    mutationKey: ['AttachInvoicesToBatchUpload'],
    mutationFn: useFetcher<AttachInvoicesToBatchUploadMutation, AttachInvoicesToBatchUploadMutationVariables>(
      AttachInvoicesToBatchUploadDocument,
    ),
    ...options,
  });
};

export const ConfirmInvoiceDocument = `
    mutation ConfirmInvoice($input: ConfirmInvoiceInput!) {
  confirmInvoice(input: $input) {
    id
  }
}
    `;

export const useConfirmInvoiceMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<ConfirmInvoiceMutation, TError, ConfirmInvoiceMutationVariables, TContext>,
) => {
  return useMutation<ConfirmInvoiceMutation, TError, ConfirmInvoiceMutationVariables, TContext>({
    mutationKey: ['ConfirmInvoice'],
    mutationFn: useFetcher<ConfirmInvoiceMutation, ConfirmInvoiceMutationVariables>(ConfirmInvoiceDocument),
    ...options,
  });
};

export const ConnectBankDocument = `
    mutation ConnectBank($input: AuthenticateBankInput!) {
  connectBank(input: $input) {
    redirectUrl
  }
}
    `;

export const useConnectBankMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<ConnectBankMutation, TError, ConnectBankMutationVariables, TContext>,
) => {
  return useMutation<ConnectBankMutation, TError, ConnectBankMutationVariables, TContext>({
    mutationKey: ['ConnectBank'],
    mutationFn: useFetcher<ConnectBankMutation, ConnectBankMutationVariables>(ConnectBankDocument),
    ...options,
  });
};

export const CreateBatchDocument = `
    mutation CreateBatch($input: CreateBatchUploadInput!) {
  createBatchUpload(input: $input) {
    ...BatchUpload
  }
}
    ${BatchUploadFragmentDoc}`;

export const useCreateBatchMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreateBatchMutation, TError, CreateBatchMutationVariables, TContext>,
) => {
  return useMutation<CreateBatchMutation, TError, CreateBatchMutationVariables, TContext>({
    mutationKey: ['CreateBatch'],
    mutationFn: useFetcher<CreateBatchMutation, CreateBatchMutationVariables>(CreateBatchDocument),
    ...options,
  });
};

export const CreateBatchPaymentDocument = `
    mutation CreateBatchPayment($id: String!, $plan: Plan!) {
  createBatchPayment(id: $id, plan: $plan) {
    clientSecret
    paymentRequired
  }
}
    `;

export const useCreateBatchPaymentMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreateBatchPaymentMutation, TError, CreateBatchPaymentMutationVariables, TContext>,
) => {
  return useMutation<CreateBatchPaymentMutation, TError, CreateBatchPaymentMutationVariables, TContext>({
    mutationKey: ['CreateBatchPayment'],
    mutationFn: useFetcher<CreateBatchPaymentMutation, CreateBatchPaymentMutationVariables>(CreateBatchPaymentDocument),
    ...options,
  });
};

export const CreateCustomerDocument = `
    mutation CreateCustomer($customer: CustomerCreateInput!) {
  createCustomer(customer: $customer) {
    ...CustomerFragment
  }
}
    ${CustomerFragmentFragmentDoc}`;

export const useCreateCustomerMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>,
) => {
  return useMutation<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>({
    mutationKey: ['CreateCustomer'],
    mutationFn: useFetcher<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument),
    ...options,
  });
};

export const CreateInvoiceDocument = `
    mutation CreateInvoice {
  createInvoice {
    id
  }
}
    `;

export const useCreateInvoiceMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreateInvoiceMutation, TError, CreateInvoiceMutationVariables, TContext>,
) => {
  return useMutation<CreateInvoiceMutation, TError, CreateInvoiceMutationVariables, TContext>({
    mutationKey: ['CreateInvoice'],
    mutationFn: useFetcher<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument),
    ...options,
  });
};

export const CreateInvoiceManuallyDocument = `
    mutation CreateInvoiceManually($input: CreateInvoiceManuallyInput!) {
  createInvoiceManually(input: $input) {
    id
  }
}
    `;

export const useCreateInvoiceManuallyMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreateInvoiceManuallyMutation, TError, CreateInvoiceManuallyMutationVariables, TContext>,
) => {
  return useMutation<CreateInvoiceManuallyMutation, TError, CreateInvoiceManuallyMutationVariables, TContext>({
    mutationKey: ['CreateInvoiceManually'],
    mutationFn: useFetcher<CreateInvoiceManuallyMutation, CreateInvoiceManuallyMutationVariables>(
      CreateInvoiceManuallyDocument,
    ),
    ...options,
  });
};

export const CreateInvoicesFromJsonDocument = `
    mutation CreateInvoicesFromJson($input: CreateInvoicesFromMappedDataInput!) {
  createInvoicesFromJson(input: $input) {
    id
  }
}
    `;

export const useCreateInvoicesFromJsonMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<
    CreateInvoicesFromJsonMutation,
    TError,
    CreateInvoicesFromJsonMutationVariables,
    TContext
  >,
) => {
  return useMutation<CreateInvoicesFromJsonMutation, TError, CreateInvoicesFromJsonMutationVariables, TContext>({
    mutationKey: ['CreateInvoicesFromJson'],
    mutationFn: useFetcher<CreateInvoicesFromJsonMutation, CreateInvoicesFromJsonMutationVariables>(
      CreateInvoicesFromJsonDocument,
    ),
    ...options,
  });
};

export const CreatePaymentDocument = `
    mutation CreatePayment($id: String!, $plan: Plan!) {
  createPayment(id: $id, plan: $plan) {
    clientSecret
    paymentRequired
  }
}
    `;

export const useCreatePaymentMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreatePaymentMutation, TError, CreatePaymentMutationVariables, TContext>,
) => {
  return useMutation<CreatePaymentMutation, TError, CreatePaymentMutationVariables, TContext>({
    mutationKey: ['CreatePayment'],
    mutationFn: useFetcher<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument),
    ...options,
  });
};

export const CreateScenarioDocument = `
    mutation CreateScenario($input: ScenarioCreateInput!) {
  createScenario(input: $input) {
    id
  }
}
    `;

export const useCreateScenarioMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreateScenarioMutation, TError, CreateScenarioMutationVariables, TContext>,
) => {
  return useMutation<CreateScenarioMutation, TError, CreateScenarioMutationVariables, TContext>({
    mutationKey: ['CreateScenario'],
    mutationFn: useFetcher<CreateScenarioMutation, CreateScenarioMutationVariables>(CreateScenarioDocument),
    ...options,
  });
};

export const CreateVendorDocument = `
    mutation CreateVendor($vendor: VendorCreateInput!) {
  createVendor(vendor: $vendor) {
    ...VendorFragment
  }
}
    ${VendorFragmentFragmentDoc}`;

export const useCreateVendorMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreateVendorMutation, TError, CreateVendorMutationVariables, TContext>,
) => {
  return useMutation<CreateVendorMutation, TError, CreateVendorMutationVariables, TContext>({
    mutationKey: ['CreateVendor'],
    mutationFn: useFetcher<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument),
    ...options,
  });
};

export const DeleteScenarioDocument = `
    mutation DeleteScenario($id: String!) {
  deleteScenario(id: $id)
}
    `;

export const useDeleteScenarioMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<DeleteScenarioMutation, TError, DeleteScenarioMutationVariables, TContext>,
) => {
  return useMutation<DeleteScenarioMutation, TError, DeleteScenarioMutationVariables, TContext>({
    mutationKey: ['DeleteScenario'],
    mutationFn: useFetcher<DeleteScenarioMutation, DeleteScenarioMutationVariables>(DeleteScenarioDocument),
    ...options,
  });
};

export const DenyUnsupportedFileContactConsentDocument = `
    mutation denyUnsupportedFileContactConsent($id: String!) {
  denyUnsupportedFileContactConsent(id: $id) {
    success
  }
}
    `;

export const useDenyUnsupportedFileContactConsentMutation = <
  TError = { message: string; code: number },
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DenyUnsupportedFileContactConsentMutation,
    TError,
    DenyUnsupportedFileContactConsentMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DenyUnsupportedFileContactConsentMutation,
    TError,
    DenyUnsupportedFileContactConsentMutationVariables,
    TContext
  >({
    mutationKey: ['denyUnsupportedFileContactConsent'],
    mutationFn: useFetcher<
      DenyUnsupportedFileContactConsentMutation,
      DenyUnsupportedFileContactConsentMutationVariables
    >(DenyUnsupportedFileContactConsentDocument),
    ...options,
  });
};

export const DisconnectBankDocument = `
    mutation DisconnectBank($id: String!) {
  disconnectBank(id: $id)
}
    `;

export const useDisconnectBankMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<DisconnectBankMutation, TError, DisconnectBankMutationVariables, TContext>,
) => {
  return useMutation<DisconnectBankMutation, TError, DisconnectBankMutationVariables, TContext>({
    mutationKey: ['DisconnectBank'],
    mutationFn: useFetcher<DisconnectBankMutation, DisconnectBankMutationVariables>(DisconnectBankDocument),
    ...options,
  });
};

export const EditInvoiceDocument = `
    mutation EditInvoice($input: EditInvoiceInput!) {
  editInvoice(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;

export const useEditInvoiceMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<EditInvoiceMutation, TError, EditInvoiceMutationVariables, TContext>,
) => {
  return useMutation<EditInvoiceMutation, TError, EditInvoiceMutationVariables, TContext>({
    mutationKey: ['EditInvoice'],
    mutationFn: useFetcher<EditInvoiceMutation, EditInvoiceMutationVariables>(EditInvoiceDocument),
    ...options,
  });
};

export const EndInvoiceRemindingDocument = `
    mutation EndInvoiceReminding($invoiceId: String!) {
  endReminding(invoiceId: $invoiceId) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;

export const useEndInvoiceRemindingMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<EndInvoiceRemindingMutation, TError, EndInvoiceRemindingMutationVariables, TContext>,
) => {
  return useMutation<EndInvoiceRemindingMutation, TError, EndInvoiceRemindingMutationVariables, TContext>({
    mutationKey: ['EndInvoiceReminding'],
    mutationFn: useFetcher<EndInvoiceRemindingMutation, EndInvoiceRemindingMutationVariables>(
      EndInvoiceRemindingDocument,
    ),
    ...options,
  });
};

export const EscalateUnpaidInvoiceDocument = `
    mutation EscalateUnpaidInvoice($input: EscalateUnpaidInvoiceInput!) {
  escalateUnpaidInvoice(input: $input)
}
    `;

export const useEscalateUnpaidInvoiceMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<EscalateUnpaidInvoiceMutation, TError, EscalateUnpaidInvoiceMutationVariables, TContext>,
) => {
  return useMutation<EscalateUnpaidInvoiceMutation, TError, EscalateUnpaidInvoiceMutationVariables, TContext>({
    mutationKey: ['EscalateUnpaidInvoice'],
    mutationFn: useFetcher<EscalateUnpaidInvoiceMutation, EscalateUnpaidInvoiceMutationVariables>(
      EscalateUnpaidInvoiceDocument,
    ),
    ...options,
  });
};

export const RequestNewPlanDocument = `
    mutation RequestNewPlan($invoiceId: String!) {
  requestNewPlan(id: $invoiceId) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;

export const useRequestNewPlanMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<RequestNewPlanMutation, TError, RequestNewPlanMutationVariables, TContext>,
) => {
  return useMutation<RequestNewPlanMutation, TError, RequestNewPlanMutationVariables, TContext>({
    mutationKey: ['RequestNewPlan'],
    mutationFn: useFetcher<RequestNewPlanMutation, RequestNewPlanMutationVariables>(RequestNewPlanDocument),
    ...options,
  });
};

export const ResendVerificationEmailDocument = `
    mutation ResendVerificationEmail {
  resendVerificationEmail
}
    `;

export const useResendVerificationEmailMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<
    ResendVerificationEmailMutation,
    TError,
    ResendVerificationEmailMutationVariables,
    TContext
  >,
) => {
  return useMutation<ResendVerificationEmailMutation, TError, ResendVerificationEmailMutationVariables, TContext>({
    mutationKey: ['ResendVerificationEmail'],
    mutationFn: useFetcher<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(
      ResendVerificationEmailDocument,
    ),
    ...options,
  });
};

export const UpdateAdminUserDocument = `
    mutation UpdateAdminUser($userId: String!, $input: AdminUserInput!) {
  updateAdminUser(id: $userId, input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

export const useUpdateAdminUserMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<UpdateAdminUserMutation, TError, UpdateAdminUserMutationVariables, TContext>,
) => {
  return useMutation<UpdateAdminUserMutation, TError, UpdateAdminUserMutationVariables, TContext>({
    mutationKey: ['UpdateAdminUser'],
    mutationFn: useFetcher<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>(UpdateAdminUserDocument),
    ...options,
  });
};

export const UpdateCustomerDocument = `
    mutation UpdateCustomer($customer: CustomerUpdateInput!) {
  updateCustomer(customer: $customer) {
    ...CustomerFragment
  }
}
    ${CustomerFragmentFragmentDoc}`;

export const useUpdateCustomerMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<UpdateCustomerMutation, TError, UpdateCustomerMutationVariables, TContext>,
) => {
  return useMutation<UpdateCustomerMutation, TError, UpdateCustomerMutationVariables, TContext>({
    mutationKey: ['UpdateCustomer'],
    mutationFn: useFetcher<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument),
    ...options,
  });
};

export const UpdateInvoiceAmountDueDocument = `
    mutation UpdateInvoiceAmountDue($invoiceId: String!, $amountDue: Float!) {
  setDueAmount(id: $invoiceId, amountDue: $amountDue) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;

export const useUpdateInvoiceAmountDueMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateInvoiceAmountDueMutation,
    TError,
    UpdateInvoiceAmountDueMutationVariables,
    TContext
  >,
) => {
  return useMutation<UpdateInvoiceAmountDueMutation, TError, UpdateInvoiceAmountDueMutationVariables, TContext>({
    mutationKey: ['UpdateInvoiceAmountDue'],
    mutationFn: useFetcher<UpdateInvoiceAmountDueMutation, UpdateInvoiceAmountDueMutationVariables>(
      UpdateInvoiceAmountDueDocument,
    ),
    ...options,
  });
};

export const UpdateScenarioDocument = `
    mutation UpdateScenario($input: ScenarioUpdateInput!) {
  updateScenario(input: $input) {
    id
  }
}
    `;

export const useUpdateScenarioMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<UpdateScenarioMutation, TError, UpdateScenarioMutationVariables, TContext>,
) => {
  return useMutation<UpdateScenarioMutation, TError, UpdateScenarioMutationVariables, TContext>({
    mutationKey: ['UpdateScenario'],
    mutationFn: useFetcher<UpdateScenarioMutation, UpdateScenarioMutationVariables>(UpdateScenarioDocument),
    ...options,
  });
};

export const UpdateScheduledActionDocument = `
    mutation UpdateScheduledAction($input: ScheduledActionUpdateInput!) {
  updateScheduledAction(input: $input) {
    ...ScheduledActionAdminFragment
  }
}
    ${ScheduledActionAdminFragmentFragmentDoc}`;

export const useUpdateScheduledActionMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<UpdateScheduledActionMutation, TError, UpdateScheduledActionMutationVariables, TContext>,
) => {
  return useMutation<UpdateScheduledActionMutation, TError, UpdateScheduledActionMutationVariables, TContext>({
    mutationKey: ['UpdateScheduledAction'],
    mutationFn: useFetcher<UpdateScheduledActionMutation, UpdateScheduledActionMutationVariables>(
      UpdateScheduledActionDocument,
    ),
    ...options,
  });
};

export const UpdateUserDocument = `
    mutation UpdateUser($input: UserInput!) {
  updateUser(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

export const useUpdateUserMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>,
) => {
  return useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>({
    mutationKey: ['UpdateUser'],
    mutationFn: useFetcher<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument),
    ...options,
  });
};

export const UpdateVendorDocument = `
    mutation UpdateVendor($vendor: VendorUpdateInput!) {
  updateVendor(vendor: $vendor) {
    ...VendorFragment
  }
}
    ${VendorFragmentFragmentDoc}`;

export const useUpdateVendorMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<UpdateVendorMutation, TError, UpdateVendorMutationVariables, TContext>,
) => {
  return useMutation<UpdateVendorMutation, TError, UpdateVendorMutationVariables, TContext>({
    mutationKey: ['UpdateVendor'],
    mutationFn: useFetcher<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument),
    ...options,
  });
};

export const AdminClaimDocument = `
    query AdminClaim($id: String!) {
  adminInvoice(invoiceId: $id) {
    ...ClaimFragment
  }
}
    ${ClaimFragmentFragmentDoc}`;

export const useAdminClaimQuery = <TData = AdminClaimQuery, TError = { message: string; code: number }>(
  variables: AdminClaimQueryVariables,
  options?: Omit<UseQueryOptions<AdminClaimQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminClaimQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminClaimQuery, TError, TData>({
    queryKey: ['AdminClaim', variables],
    queryFn: useFetcher<AdminClaimQuery, AdminClaimQueryVariables>(AdminClaimDocument).bind(null, variables),
    ...options,
  });
};

useAdminClaimQuery.document = AdminClaimDocument;

useAdminClaimQuery.getKey = (variables: AdminClaimQueryVariables) => ['AdminClaim', variables];

export const AdminClaimDataEntriesDocument = `
    query AdminClaimDataEntries($id: String!) {
  adminInvoice(invoiceId: $id) {
    ...ClaimDataEntriesFragment
  }
}
    ${ClaimDataEntriesFragmentFragmentDoc}`;

export const useAdminClaimDataEntriesQuery = <
  TData = AdminClaimDataEntriesQuery,
  TError = { message: string; code: number },
>(
  variables: AdminClaimDataEntriesQueryVariables,
  options?: Omit<UseQueryOptions<AdminClaimDataEntriesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminClaimDataEntriesQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminClaimDataEntriesQuery, TError, TData>({
    queryKey: ['AdminClaimDataEntries', variables],
    queryFn: useFetcher<AdminClaimDataEntriesQuery, AdminClaimDataEntriesQueryVariables>(
      AdminClaimDataEntriesDocument,
    ).bind(null, variables),
    ...options,
  });
};

useAdminClaimDataEntriesQuery.document = AdminClaimDataEntriesDocument;

useAdminClaimDataEntriesQuery.getKey = (variables: AdminClaimDataEntriesQueryVariables) => [
  'AdminClaimDataEntries',
  variables,
];

export const AdminClaimIdDocument = `
    query AdminClaimId($id: String!) {
  adminInvoice(invoiceId: $id) {
    id
  }
}
    `;

export const useAdminClaimIdQuery = <TData = AdminClaimIdQuery, TError = { message: string; code: number }>(
  variables: AdminClaimIdQueryVariables,
  options?: Omit<UseQueryOptions<AdminClaimIdQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminClaimIdQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminClaimIdQuery, TError, TData>({
    queryKey: ['AdminClaimId', variables],
    queryFn: useFetcher<AdminClaimIdQuery, AdminClaimIdQueryVariables>(AdminClaimIdDocument).bind(null, variables),
    ...options,
  });
};

useAdminClaimIdQuery.document = AdminClaimIdDocument;

useAdminClaimIdQuery.getKey = (variables: AdminClaimIdQueryVariables) => ['AdminClaimId', variables];

export const AdminClaimScheduledActionsDocument = `
    query AdminClaimScheduledActions($id: String!) {
  adminInvoice(invoiceId: $id) {
    scheduledActions {
      ...ScheduledActionFragment
    }
  }
}
    ${ScheduledActionFragmentFragmentDoc}`;

export const useAdminClaimScheduledActionsQuery = <
  TData = AdminClaimScheduledActionsQuery,
  TError = { message: string; code: number },
>(
  variables: AdminClaimScheduledActionsQueryVariables,
  options?: Omit<UseQueryOptions<AdminClaimScheduledActionsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminClaimScheduledActionsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminClaimScheduledActionsQuery, TError, TData>({
    queryKey: ['AdminClaimScheduledActions', variables],
    queryFn: useFetcher<AdminClaimScheduledActionsQuery, AdminClaimScheduledActionsQueryVariables>(
      AdminClaimScheduledActionsDocument,
    ).bind(null, variables),
    ...options,
  });
};

useAdminClaimScheduledActionsQuery.document = AdminClaimScheduledActionsDocument;

useAdminClaimScheduledActionsQuery.getKey = (variables: AdminClaimScheduledActionsQueryVariables) => [
  'AdminClaimScheduledActions',
  variables,
];

export const AdminClaimsDocument = `
    query AdminClaims($query: String!, $take: Int!, $skip: Int!) {
  adminInvoices(query: $query, take: $take, skip: $skip, claim: true) {
    results {
      id
      name
      createdAt
      issueDate
      number
      amountDue
      status
      scenario {
        name
      }
      customer {
        id
        name
      }
      owner {
        id
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

export const useAdminClaimsQuery = <TData = AdminClaimsQuery, TError = { message: string; code: number }>(
  variables: AdminClaimsQueryVariables,
  options?: Omit<UseQueryOptions<AdminClaimsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminClaimsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminClaimsQuery, TError, TData>({
    queryKey: ['AdminClaims', variables],
    queryFn: useFetcher<AdminClaimsQuery, AdminClaimsQueryVariables>(AdminClaimsDocument).bind(null, variables),
    ...options,
  });
};

useAdminClaimsQuery.document = AdminClaimsDocument;

useAdminClaimsQuery.getKey = (variables: AdminClaimsQueryVariables) => ['AdminClaims', variables];

export const AdminInvoiceDocument = `
    query AdminInvoice($id: String!) {
  adminInvoice(invoiceId: $id) {
    ...InvoiceAdminFragment
  }
}
    ${InvoiceAdminFragmentFragmentDoc}`;

export const useAdminInvoiceQuery = <TData = AdminInvoiceQuery, TError = { message: string; code: number }>(
  variables: AdminInvoiceQueryVariables,
  options?: Omit<UseQueryOptions<AdminInvoiceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminInvoiceQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminInvoiceQuery, TError, TData>({
    queryKey: ['AdminInvoice', variables],
    queryFn: useFetcher<AdminInvoiceQuery, AdminInvoiceQueryVariables>(AdminInvoiceDocument).bind(null, variables),
    ...options,
  });
};

useAdminInvoiceQuery.document = AdminInvoiceDocument;

useAdminInvoiceQuery.getKey = (variables: AdminInvoiceQueryVariables) => ['AdminInvoice', variables];

export const AdminInvoiceNumberDocument = `
    query AdminInvoiceNumber($id: String!) {
  adminInvoice(invoiceId: $id) {
    number
  }
}
    `;

export const useAdminInvoiceNumberQuery = <TData = AdminInvoiceNumberQuery, TError = { message: string; code: number }>(
  variables: AdminInvoiceNumberQueryVariables,
  options?: Omit<UseQueryOptions<AdminInvoiceNumberQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminInvoiceNumberQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminInvoiceNumberQuery, TError, TData>({
    queryKey: ['AdminInvoiceNumber', variables],
    queryFn: useFetcher<AdminInvoiceNumberQuery, AdminInvoiceNumberQueryVariables>(AdminInvoiceNumberDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useAdminInvoiceNumberQuery.document = AdminInvoiceNumberDocument;

useAdminInvoiceNumberQuery.getKey = (variables: AdminInvoiceNumberQueryVariables) => ['AdminInvoiceNumber', variables];

export const AdminInvoicesDocument = `
    query AdminInvoices($query: String!, $take: Int!, $skip: Int!) {
  adminInvoices(query: $query, take: $take, skip: $skip, claim: false) {
    results {
      id
      createdAt
      issueDate
      number
      status
      remindingTone
      vendor {
        id
        name
      }
      customer {
        id
        name
      }
      owner {
        id
        firstName
        lastName
      }
      amountDue
    }
    totalCount
  }
}
    `;

export const useAdminInvoicesQuery = <TData = AdminInvoicesQuery, TError = { message: string; code: number }>(
  variables: AdminInvoicesQueryVariables,
  options?: Omit<UseQueryOptions<AdminInvoicesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminInvoicesQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminInvoicesQuery, TError, TData>({
    queryKey: ['AdminInvoices', variables],
    queryFn: useFetcher<AdminInvoicesQuery, AdminInvoicesQueryVariables>(AdminInvoicesDocument).bind(null, variables),
    ...options,
  });
};

useAdminInvoicesQuery.document = AdminInvoicesDocument;

useAdminInvoicesQuery.getKey = (variables: AdminInvoicesQueryVariables) => ['AdminInvoices', variables];

export const AdminModelsDocument = `
    query AdminModels {
  invoiceModels {
    id
    name
    fields {
      name
      required
    }
  }
}
    `;

export const useAdminModelsQuery = <TData = AdminModelsQuery, TError = { message: string; code: number }>(
  variables?: AdminModelsQueryVariables,
  options?: Omit<UseQueryOptions<AdminModelsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminModelsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminModelsQuery, TError, TData>({
    queryKey: variables === undefined ? ['AdminModels'] : ['AdminModels', variables],
    queryFn: useFetcher<AdminModelsQuery, AdminModelsQueryVariables>(AdminModelsDocument).bind(null, variables),
    ...options,
  });
};

useAdminModelsQuery.document = AdminModelsDocument;

useAdminModelsQuery.getKey = (variables?: AdminModelsQueryVariables) =>
  variables === undefined ? ['AdminModels'] : ['AdminModels', variables];

export const AdminScenarioDocument = `
    query AdminScenario($id: String!) {
  adminScenario(id: $id) {
    ...ScenarioFragment
    model {
      id
      name
      fields {
        name
        required
      }
    }
    user {
      ...UserFragment
    }
  }
}
    ${ScenarioFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;

export const useAdminScenarioQuery = <TData = AdminScenarioQuery, TError = { message: string; code: number }>(
  variables: AdminScenarioQueryVariables,
  options?: Omit<UseQueryOptions<AdminScenarioQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminScenarioQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminScenarioQuery, TError, TData>({
    queryKey: ['AdminScenario', variables],
    queryFn: useFetcher<AdminScenarioQuery, AdminScenarioQueryVariables>(AdminScenarioDocument).bind(null, variables),
    ...options,
  });
};

useAdminScenarioQuery.document = AdminScenarioDocument;

useAdminScenarioQuery.getKey = (variables: AdminScenarioQueryVariables) => ['AdminScenario', variables];

export const AdminScenarioPlansDocument = `
    query AdminScenarioPlans {
  scenarioPlans {
    ...ScenarioPlanFragment
  }
}
    ${ScenarioPlanFragmentFragmentDoc}`;

export const useAdminScenarioPlansQuery = <TData = AdminScenarioPlansQuery, TError = { message: string; code: number }>(
  variables?: AdminScenarioPlansQueryVariables,
  options?: Omit<UseQueryOptions<AdminScenarioPlansQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminScenarioPlansQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminScenarioPlansQuery, TError, TData>({
    queryKey: variables === undefined ? ['AdminScenarioPlans'] : ['AdminScenarioPlans', variables],
    queryFn: useFetcher<AdminScenarioPlansQuery, AdminScenarioPlansQueryVariables>(AdminScenarioPlansDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useAdminScenarioPlansQuery.document = AdminScenarioPlansDocument;

useAdminScenarioPlansQuery.getKey = (variables?: AdminScenarioPlansQueryVariables) =>
  variables === undefined ? ['AdminScenarioPlans'] : ['AdminScenarioPlans', variables];

export const AdminScenariosDocument = `
    query AdminScenarios($query: String!, $take: Int!, $skip: Int!) {
  adminScenarios(query: $query, take: $take, skip: $skip) {
    totalCount
    results {
      id
      name
      static
      user {
        id
        firstName
        lastName
      }
      model {
        id
        name
      }
      plan {
        ...ScenarioPlanFragment
      }
    }
  }
}
    ${ScenarioPlanFragmentFragmentDoc}`;

export const useAdminScenariosQuery = <TData = AdminScenariosQuery, TError = { message: string; code: number }>(
  variables: AdminScenariosQueryVariables,
  options?: Omit<UseQueryOptions<AdminScenariosQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminScenariosQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminScenariosQuery, TError, TData>({
    queryKey: ['AdminScenarios', variables],
    queryFn: useFetcher<AdminScenariosQuery, AdminScenariosQueryVariables>(AdminScenariosDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useAdminScenariosQuery.document = AdminScenariosDocument;

useAdminScenariosQuery.getKey = (variables: AdminScenariosQueryVariables) => ['AdminScenarios', variables];

export const AdminUsersDocument = `
    query adminUsers($query: String!, $take: Int!, $skip: Int!) {
  adminUsers(query: $query, take: $take, skip: $skip) {
    totalCount
    results {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

export const useAdminUsersQuery = <TData = AdminUsersQuery, TError = { message: string; code: number }>(
  variables: AdminUsersQueryVariables,
  options?: Omit<UseQueryOptions<AdminUsersQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AdminUsersQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AdminUsersQuery, TError, TData>({
    queryKey: ['adminUsers', variables],
    queryFn: useFetcher<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument).bind(null, variables),
    ...options,
  });
};

useAdminUsersQuery.document = AdminUsersDocument;

useAdminUsersQuery.getKey = (variables: AdminUsersQueryVariables) => ['adminUsers', variables];

export const GetAresDataDocument = `
    query GetAresData($vatId: String!) {
  queryAres(vatId: $vatId) {
    vatId
    taxId
    name
    streetAddress
    city
    country
    zip
  }
}
    `;

export const useGetAresDataQuery = <TData = GetAresDataQuery, TError = { message: string; code: number }>(
  variables: GetAresDataQueryVariables,
  options?: Omit<UseQueryOptions<GetAresDataQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAresDataQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<GetAresDataQuery, TError, TData>({
    queryKey: ['GetAresData', variables],
    queryFn: useFetcher<GetAresDataQuery, GetAresDataQueryVariables>(GetAresDataDocument).bind(null, variables),
    ...options,
  });
};

useGetAresDataQuery.document = GetAresDataDocument;

useGetAresDataQuery.getKey = (variables: GetAresDataQueryVariables) => ['GetAresData', variables];

export const AuthStatusDocument = `
    query AuthStatus {
  authStatus
}
    `;

export const useAuthStatusQuery = <TData = AuthStatusQuery, TError = { message: string; code: number }>(
  variables?: AuthStatusQueryVariables,
  options?: Omit<UseQueryOptions<AuthStatusQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AuthStatusQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<AuthStatusQuery, TError, TData>({
    queryKey: variables === undefined ? ['AuthStatus'] : ['AuthStatus', variables],
    queryFn: useFetcher<AuthStatusQuery, AuthStatusQueryVariables>(AuthStatusDocument).bind(null, variables),
    ...options,
  });
};

useAuthStatusQuery.document = AuthStatusDocument;

useAuthStatusQuery.getKey = (variables?: AuthStatusQueryVariables) =>
  variables === undefined ? ['AuthStatus'] : ['AuthStatus', variables];

export const BankConnectionsDocument = `
    query BankConnections {
  bankConnections {
    id
    provider
    status
    bankLogoUrl
    bankName
  }
}
    `;

export const useBankConnectionsQuery = <TData = BankConnectionsQuery, TError = { message: string; code: number }>(
  variables?: BankConnectionsQueryVariables,
  options?: Omit<UseQueryOptions<BankConnectionsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<BankConnectionsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<BankConnectionsQuery, TError, TData>({
    queryKey: variables === undefined ? ['BankConnections'] : ['BankConnections', variables],
    queryFn: useFetcher<BankConnectionsQuery, BankConnectionsQueryVariables>(BankConnectionsDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useBankConnectionsQuery.document = BankConnectionsDocument;

useBankConnectionsQuery.getKey = (variables?: BankConnectionsQueryVariables) =>
  variables === undefined ? ['BankConnections'] : ['BankConnections', variables];

export const BatchUploadDocument = `
    query BatchUpload($id: String!) {
  batchUpload(id: $id) {
    ...BatchUpload
  }
}
    ${BatchUploadFragmentDoc}`;

export const useBatchUploadQuery = <TData = BatchUploadQuery, TError = { message: string; code: number }>(
  variables: BatchUploadQueryVariables,
  options?: Omit<UseQueryOptions<BatchUploadQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<BatchUploadQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<BatchUploadQuery, TError, TData>({
    queryKey: ['BatchUpload', variables],
    queryFn: useFetcher<BatchUploadQuery, BatchUploadQueryVariables>(BatchUploadDocument).bind(null, variables),
    ...options,
  });
};

useBatchUploadQuery.document = BatchUploadDocument;

useBatchUploadQuery.getKey = (variables: BatchUploadQueryVariables) => ['BatchUpload', variables];

export const BatchUploadStatusDocument = `
    query BatchUploadStatus($id: String!) {
  batchUpload(id: $id) {
    ...BatchUploadStatus
  }
}
    ${BatchUploadStatusFragmentDoc}`;

export const useBatchUploadStatusQuery = <TData = BatchUploadStatusQuery, TError = { message: string; code: number }>(
  variables: BatchUploadStatusQueryVariables,
  options?: Omit<UseQueryOptions<BatchUploadStatusQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<BatchUploadStatusQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<BatchUploadStatusQuery, TError, TData>({
    queryKey: ['BatchUploadStatus', variables],
    queryFn: useFetcher<BatchUploadStatusQuery, BatchUploadStatusQueryVariables>(BatchUploadStatusDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useBatchUploadStatusQuery.document = BatchUploadStatusDocument;

useBatchUploadStatusQuery.getKey = (variables: BatchUploadStatusQueryVariables) => ['BatchUploadStatus', variables];

export const ClaimDocument = `
    query Claim($id: String!) {
  invoice(id: $id) {
    ...ClaimFragment
  }
}
    ${ClaimFragmentFragmentDoc}`;

export const useClaimQuery = <TData = ClaimQuery, TError = { message: string; code: number }>(
  variables: ClaimQueryVariables,
  options?: Omit<UseQueryOptions<ClaimQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ClaimQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ClaimQuery, TError, TData>({
    queryKey: ['Claim', variables],
    queryFn: useFetcher<ClaimQuery, ClaimQueryVariables>(ClaimDocument).bind(null, variables),
    ...options,
  });
};

useClaimQuery.document = ClaimDocument;

useClaimQuery.getKey = (variables: ClaimQueryVariables) => ['Claim', variables];

export const ClaimDataEntriesDocument = `
    query ClaimDataEntries($id: String!) {
  invoice(id: $id) {
    ...ClaimDataEntriesFragment
  }
}
    ${ClaimDataEntriesFragmentFragmentDoc}`;

export const useClaimDataEntriesQuery = <TData = ClaimDataEntriesQuery, TError = { message: string; code: number }>(
  variables: ClaimDataEntriesQueryVariables,
  options?: Omit<UseQueryOptions<ClaimDataEntriesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ClaimDataEntriesQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ClaimDataEntriesQuery, TError, TData>({
    queryKey: ['ClaimDataEntries', variables],
    queryFn: useFetcher<ClaimDataEntriesQuery, ClaimDataEntriesQueryVariables>(ClaimDataEntriesDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useClaimDataEntriesQuery.document = ClaimDataEntriesDocument;

useClaimDataEntriesQuery.getKey = (variables: ClaimDataEntriesQueryVariables) => ['ClaimDataEntries', variables];

export const ClaimScheduledActionsDocument = `
    query ClaimScheduledActions($id: String!) {
  invoice(id: $id) {
    scheduledActions {
      ...ScheduledActionFragment
    }
  }
}
    ${ScheduledActionFragmentFragmentDoc}`;

export const useClaimScheduledActionsQuery = <
  TData = ClaimScheduledActionsQuery,
  TError = { message: string; code: number },
>(
  variables: ClaimScheduledActionsQueryVariables,
  options?: Omit<UseQueryOptions<ClaimScheduledActionsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ClaimScheduledActionsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ClaimScheduledActionsQuery, TError, TData>({
    queryKey: ['ClaimScheduledActions', variables],
    queryFn: useFetcher<ClaimScheduledActionsQuery, ClaimScheduledActionsQueryVariables>(
      ClaimScheduledActionsDocument,
    ).bind(null, variables),
    ...options,
  });
};

useClaimScheduledActionsQuery.document = ClaimScheduledActionsDocument;

useClaimScheduledActionsQuery.getKey = (variables: ClaimScheduledActionsQueryVariables) => [
  'ClaimScheduledActions',
  variables,
];

export const ClaimsDocument = `
    query Claims {
  invoices(claim: true, archived: false) {
    id
    name
    number
    amountDue
    createdAt
    plan
    planPaid
    settled
    status
    currency
    annotationComplete
    customer {
      name
    }
    vendor {
      name
    }
    batchUpload {
      id
      planPaid
      type
    }
    scheduledActions {
      id
      scheduledAt
      doneAt
      action
    }
    isAnnotated
    canBeArchived
  }
}
    `;

export const useClaimsQuery = <TData = ClaimsQuery, TError = { message: string; code: number }>(
  variables?: ClaimsQueryVariables,
  options?: Omit<UseQueryOptions<ClaimsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ClaimsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ClaimsQuery, TError, TData>({
    queryKey: variables === undefined ? ['Claims'] : ['Claims', variables],
    queryFn: useFetcher<ClaimsQuery, ClaimsQueryVariables>(ClaimsDocument).bind(null, variables),
    ...options,
  });
};

useClaimsQuery.document = ClaimsDocument;

useClaimsQuery.getKey = (variables?: ClaimsQueryVariables) =>
  variables === undefined ? ['Claims'] : ['Claims', variables];

export const CustomerDocument = `
    query Customer($id: String!) {
  customer(id: $id) {
    ...CustomerFragment
  }
}
    ${CustomerFragmentFragmentDoc}`;

export const useCustomerQuery = <TData = CustomerQuery, TError = { message: string; code: number }>(
  variables: CustomerQueryVariables,
  options?: Omit<UseQueryOptions<CustomerQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<CustomerQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<CustomerQuery, TError, TData>({
    queryKey: ['Customer', variables],
    queryFn: useFetcher<CustomerQuery, CustomerQueryVariables>(CustomerDocument).bind(null, variables),
    ...options,
  });
};

useCustomerQuery.document = CustomerDocument;

useCustomerQuery.getKey = (variables: CustomerQueryVariables) => ['Customer', variables];

export const CustomersDocument = `
    query Customers {
  customers {
    ...CustomerFragment
  }
}
    ${CustomerFragmentFragmentDoc}`;

export const useCustomersQuery = <TData = CustomersQuery, TError = { message: string; code: number }>(
  variables?: CustomersQueryVariables,
  options?: Omit<UseQueryOptions<CustomersQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<CustomersQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<CustomersQuery, TError, TData>({
    queryKey: variables === undefined ? ['Customers'] : ['Customers', variables],
    queryFn: useFetcher<CustomersQuery, CustomersQueryVariables>(CustomersDocument).bind(null, variables),
    ...options,
  });
};

useCustomersQuery.document = CustomersDocument;

useCustomersQuery.getKey = (variables?: CustomersQueryVariables) =>
  variables === undefined ? ['Customers'] : ['Customers', variables];

export const InvoiceDocument = `
    query Invoice($id: String!) {
  invoice(id: $id) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;

export const useInvoiceQuery = <TData = InvoiceQuery, TError = { message: string; code: number }>(
  variables: InvoiceQueryVariables,
  options?: Omit<UseQueryOptions<InvoiceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<InvoiceQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<InvoiceQuery, TError, TData>({
    queryKey: ['Invoice', variables],
    queryFn: useFetcher<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument).bind(null, variables),
    ...options,
  });
};

useInvoiceQuery.document = InvoiceDocument;

useInvoiceQuery.getKey = (variables: InvoiceQueryVariables) => ['Invoice', variables];

export const InvoicePlanPriceDocument = `
    query InvoicePlanPrice($id: String!) {
  invoice(id: $id) {
    id
    standardPrice: price(plan: STANDARD)
    standardDiscount: discount(plan: STANDARD)
    trialPrice: price(plan: TRIAL)
    trialDiscount: discount(plan: TRIAL)
    customer {
      id
      phoneNumber
      email
    }
  }
}
    `;

export const useInvoicePlanPriceQuery = <TData = InvoicePlanPriceQuery, TError = { message: string; code: number }>(
  variables: InvoicePlanPriceQueryVariables,
  options?: Omit<UseQueryOptions<InvoicePlanPriceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<InvoicePlanPriceQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<InvoicePlanPriceQuery, TError, TData>({
    queryKey: ['InvoicePlanPrice', variables],
    queryFn: useFetcher<InvoicePlanPriceQuery, InvoicePlanPriceQueryVariables>(InvoicePlanPriceDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useInvoicePlanPriceQuery.document = InvoicePlanPriceDocument;

useInvoicePlanPriceQuery.getKey = (variables: InvoicePlanPriceQueryVariables) => ['InvoicePlanPrice', variables];

export const InvoiceStatusDocument = `
    query InvoiceStatus($id: String!) {
  invoice(id: $id) {
    id
    status
    batchUpload {
      id
      planPaid
      type
    }
    isAnnotated
  }
}
    `;

export const useInvoiceStatusQuery = <TData = InvoiceStatusQuery, TError = { message: string; code: number }>(
  variables: InvoiceStatusQueryVariables,
  options?: Omit<UseQueryOptions<InvoiceStatusQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<InvoiceStatusQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<InvoiceStatusQuery, TError, TData>({
    queryKey: ['InvoiceStatus', variables],
    queryFn: useFetcher<InvoiceStatusQuery, InvoiceStatusQueryVariables>(InvoiceStatusDocument).bind(null, variables),
    ...options,
  });
};

useInvoiceStatusQuery.document = InvoiceStatusDocument;

useInvoiceStatusQuery.getKey = (variables: InvoiceStatusQueryVariables) => ['InvoiceStatus', variables];

export const InvoicesDocument = `
    query Invoices {
  invoices(claim: false, archived: false) {
    id
    number
    amountDue
    createdAt
    issueDate
    plan
    planPaid
    settled
    status
    currency
    annotationComplete
    customer {
      name
    }
    vendor {
      name
    }
    batchUpload {
      id
      planPaid
      type
    }
    scheduledActions {
      id
      scheduledAt
      doneAt
      action
    }
    isAnnotated
    canBeArchived
  }
}
    `;

export const useInvoicesQuery = <TData = InvoicesQuery, TError = { message: string; code: number }>(
  variables?: InvoicesQueryVariables,
  options?: Omit<UseQueryOptions<InvoicesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<InvoicesQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<InvoicesQuery, TError, TData>({
    queryKey: variables === undefined ? ['Invoices'] : ['Invoices', variables],
    queryFn: useFetcher<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument).bind(null, variables),
    ...options,
  });
};

useInvoicesQuery.document = InvoicesDocument;

useInvoicesQuery.getKey = (variables?: InvoicesQueryVariables) =>
  variables === undefined ? ['Invoices'] : ['Invoices', variables];

export const ReceivedMessagesDocument = `
    query ReceivedMessages {
  receivedMessages {
    ...ReceivedMessageFragment
  }
}
    ${ReceivedMessageFragmentFragmentDoc}`;

export const useReceivedMessagesQuery = <TData = ReceivedMessagesQuery, TError = { message: string; code: number }>(
  variables?: ReceivedMessagesQueryVariables,
  options?: Omit<UseQueryOptions<ReceivedMessagesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ReceivedMessagesQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ReceivedMessagesQuery, TError, TData>({
    queryKey: variables === undefined ? ['ReceivedMessages'] : ['ReceivedMessages', variables],
    queryFn: useFetcher<ReceivedMessagesQuery, ReceivedMessagesQueryVariables>(ReceivedMessagesDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useReceivedMessagesQuery.document = ReceivedMessagesDocument;

useReceivedMessagesQuery.getKey = (variables?: ReceivedMessagesQueryVariables) =>
  variables === undefined ? ['ReceivedMessages'] : ['ReceivedMessages', variables];

export const ScenarioDocument = `
    query Scenario($id: String!) {
  scenario(id: $id) {
    ...ScenarioFragment
  }
}
    ${ScenarioFragmentFragmentDoc}`;

export const useScenarioQuery = <TData = ScenarioQuery, TError = { message: string; code: number }>(
  variables: ScenarioQueryVariables,
  options?: Omit<UseQueryOptions<ScenarioQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScenarioQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ScenarioQuery, TError, TData>({
    queryKey: ['Scenario', variables],
    queryFn: useFetcher<ScenarioQuery, ScenarioQueryVariables>(ScenarioDocument).bind(null, variables),
    ...options,
  });
};

useScenarioQuery.document = ScenarioDocument;

useScenarioQuery.getKey = (variables: ScenarioQueryVariables) => ['Scenario', variables];

export const ScenariosDocument = `
    query Scenarios {
  scenarios {
    ...ScenarioFragment
  }
}
    ${ScenarioFragmentFragmentDoc}`;

export const useScenariosQuery = <TData = ScenariosQuery, TError = { message: string; code: number }>(
  variables?: ScenariosQueryVariables,
  options?: Omit<UseQueryOptions<ScenariosQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScenariosQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ScenariosQuery, TError, TData>({
    queryKey: variables === undefined ? ['Scenarios'] : ['Scenarios', variables],
    queryFn: useFetcher<ScenariosQuery, ScenariosQueryVariables>(ScenariosDocument).bind(null, variables),
    ...options,
  });
};

useScenariosQuery.document = ScenariosDocument;

useScenariosQuery.getKey = (variables?: ScenariosQueryVariables) =>
  variables === undefined ? ['Scenarios'] : ['Scenarios', variables];

export const ScheduledActionDocument = `
    query ScheduledAction($id: String!) {
  scheduledAction(id: $id) {
    ...ScheduledActionAdminFragment
  }
}
    ${ScheduledActionAdminFragmentFragmentDoc}`;

export const useScheduledActionQuery = <TData = ScheduledActionQuery, TError = { message: string; code: number }>(
  variables: ScheduledActionQueryVariables,
  options?: Omit<UseQueryOptions<ScheduledActionQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScheduledActionQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ScheduledActionQuery, TError, TData>({
    queryKey: ['ScheduledAction', variables],
    queryFn: useFetcher<ScheduledActionQuery, ScheduledActionQueryVariables>(ScheduledActionDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useScheduledActionQuery.document = ScheduledActionDocument;

useScheduledActionQuery.getKey = (variables: ScheduledActionQueryVariables) => ['ScheduledAction', variables];

export const ScheduledActionTitleDocument = `
    query ScheduledActionTitle($id: String!) {
  scheduledAction(id: $id) {
    id
    action
    vendorName
    customerName
    invoiceClaim
  }
}
    `;

export const useScheduledActionTitleQuery = <
  TData = ScheduledActionTitleQuery,
  TError = { message: string; code: number },
>(
  variables: ScheduledActionTitleQueryVariables,
  options?: Omit<UseQueryOptions<ScheduledActionTitleQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScheduledActionTitleQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ScheduledActionTitleQuery, TError, TData>({
    queryKey: ['ScheduledActionTitle', variables],
    queryFn: useFetcher<ScheduledActionTitleQuery, ScheduledActionTitleQueryVariables>(
      ScheduledActionTitleDocument,
    ).bind(null, variables),
    ...options,
  });
};

useScheduledActionTitleQuery.document = ScheduledActionTitleDocument;

useScheduledActionTitleQuery.getKey = (variables: ScheduledActionTitleQueryVariables) => [
  'ScheduledActionTitle',
  variables,
];

export const ScheduledActionsForTodayDocument = `
    query ScheduledActionsForToday {
  scheduledActionsForToday {
    id
    scheduledAt
    doneAt
    action
    success
    customerName
    vendorName
    invoiceId
    invoiceNumber
    invoiceClaim
  }
}
    `;

export const useScheduledActionsForTodayQuery = <
  TData = ScheduledActionsForTodayQuery,
  TError = { message: string; code: number },
>(
  variables?: ScheduledActionsForTodayQueryVariables,
  options?: Omit<UseQueryOptions<ScheduledActionsForTodayQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScheduledActionsForTodayQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ScheduledActionsForTodayQuery, TError, TData>({
    queryKey: variables === undefined ? ['ScheduledActionsForToday'] : ['ScheduledActionsForToday', variables],
    queryFn: useFetcher<ScheduledActionsForTodayQuery, ScheduledActionsForTodayQueryVariables>(
      ScheduledActionsForTodayDocument,
    ).bind(null, variables),
    ...options,
  });
};

useScheduledActionsForTodayQuery.document = ScheduledActionsForTodayDocument;

useScheduledActionsForTodayQuery.getKey = (variables?: ScheduledActionsForTodayQueryVariables) =>
  variables === undefined ? ['ScheduledActionsForToday'] : ['ScheduledActionsForToday', variables];

export const ScheduledActionsDoneTodayDocument = `
    query ScheduledActionsDoneToday {
  scheduledActionsDoneToday {
    id
    scheduledAt
    doneAt
    action
    success
    customerName
    vendorName
    invoiceNumber
    invoiceId
    invoiceClaim
  }
}
    `;

export const useScheduledActionsDoneTodayQuery = <
  TData = ScheduledActionsDoneTodayQuery,
  TError = { message: string; code: number },
>(
  variables?: ScheduledActionsDoneTodayQueryVariables,
  options?: Omit<UseQueryOptions<ScheduledActionsDoneTodayQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScheduledActionsDoneTodayQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ScheduledActionsDoneTodayQuery, TError, TData>({
    queryKey: variables === undefined ? ['ScheduledActionsDoneToday'] : ['ScheduledActionsDoneToday', variables],
    queryFn: useFetcher<ScheduledActionsDoneTodayQuery, ScheduledActionsDoneTodayQueryVariables>(
      ScheduledActionsDoneTodayDocument,
    ).bind(null, variables),
    ...options,
  });
};

useScheduledActionsDoneTodayQuery.document = ScheduledActionsDoneTodayDocument;

useScheduledActionsDoneTodayQuery.getKey = (variables?: ScheduledActionsDoneTodayQueryVariables) =>
  variables === undefined ? ['ScheduledActionsDoneToday'] : ['ScheduledActionsDoneToday', variables];

export const ScheduledActionInvoiceDocument = `
    query ScheduledActionInvoice($id: String!) {
  scheduledAction(id: $id) {
    id
    invoice {
      ...InvoiceAdminFragment
    }
  }
}
    ${InvoiceAdminFragmentFragmentDoc}`;

export const useScheduledActionInvoiceQuery = <
  TData = ScheduledActionInvoiceQuery,
  TError = { message: string; code: number },
>(
  variables: ScheduledActionInvoiceQueryVariables,
  options?: Omit<UseQueryOptions<ScheduledActionInvoiceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScheduledActionInvoiceQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ScheduledActionInvoiceQuery, TError, TData>({
    queryKey: ['ScheduledActionInvoice', variables],
    queryFn: useFetcher<ScheduledActionInvoiceQuery, ScheduledActionInvoiceQueryVariables>(
      ScheduledActionInvoiceDocument,
    ).bind(null, variables),
    ...options,
  });
};

useScheduledActionInvoiceQuery.document = ScheduledActionInvoiceDocument;

useScheduledActionInvoiceQuery.getKey = (variables: ScheduledActionInvoiceQueryVariables) => [
  'ScheduledActionInvoice',
  variables,
];

export const ScheduledActionInvoiceClaimDocument = `
    query ScheduledActionInvoiceClaim($id: String!) {
  scheduledAction(id: $id) {
    id
    invoiceClaim
    invoiceId
  }
}
    `;

export const useScheduledActionInvoiceClaimQuery = <
  TData = ScheduledActionInvoiceClaimQuery,
  TError = { message: string; code: number },
>(
  variables: ScheduledActionInvoiceClaimQueryVariables,
  options?: Omit<UseQueryOptions<ScheduledActionInvoiceClaimQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScheduledActionInvoiceClaimQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ScheduledActionInvoiceClaimQuery, TError, TData>({
    queryKey: ['ScheduledActionInvoiceClaim', variables],
    queryFn: useFetcher<ScheduledActionInvoiceClaimQuery, ScheduledActionInvoiceClaimQueryVariables>(
      ScheduledActionInvoiceClaimDocument,
    ).bind(null, variables),
    ...options,
  });
};

useScheduledActionInvoiceClaimQuery.document = ScheduledActionInvoiceClaimDocument;

useScheduledActionInvoiceClaimQuery.getKey = (variables: ScheduledActionInvoiceClaimQueryVariables) => [
  'ScheduledActionInvoiceClaim',
  variables,
];

export const SupportedBanksDocument = `
    query SupportedBanks {
  supportedBanks {
    name
    logoUrl
    paymentProvider
  }
}
    `;

export const useSupportedBanksQuery = <TData = SupportedBanksQuery, TError = { message: string; code: number }>(
  variables?: SupportedBanksQueryVariables,
  options?: Omit<UseQueryOptions<SupportedBanksQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<SupportedBanksQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<SupportedBanksQuery, TError, TData>({
    queryKey: variables === undefined ? ['SupportedBanks'] : ['SupportedBanks', variables],
    queryFn: useFetcher<SupportedBanksQuery, SupportedBanksQueryVariables>(SupportedBanksDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useSupportedBanksQuery.document = SupportedBanksDocument;

useSupportedBanksQuery.getKey = (variables?: SupportedBanksQueryVariables) =>
  variables === undefined ? ['SupportedBanks'] : ['SupportedBanks', variables];

export const UserDocument = `
    query User {
  user {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

export const useUserQuery = <TData = UserQuery, TError = { message: string; code: number }>(
  variables?: UserQueryVariables,
  options?: Omit<UseQueryOptions<UserQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<UserQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<UserQuery, TError, TData>({
    queryKey: variables === undefined ? ['User'] : ['User', variables],
    queryFn: useFetcher<UserQuery, UserQueryVariables>(UserDocument).bind(null, variables),
    ...options,
  });
};

useUserQuery.document = UserDocument;

useUserQuery.getKey = (variables?: UserQueryVariables) => (variables === undefined ? ['User'] : ['User', variables]);

export const VendorDocument = `
    query Vendor($id: String!) {
  vendor(id: $id) {
    ...VendorFragment
  }
}
    ${VendorFragmentFragmentDoc}`;

export const useVendorQuery = <TData = VendorQuery, TError = { message: string; code: number }>(
  variables: VendorQueryVariables,
  options?: Omit<UseQueryOptions<VendorQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<VendorQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<VendorQuery, TError, TData>({
    queryKey: ['Vendor', variables],
    queryFn: useFetcher<VendorQuery, VendorQueryVariables>(VendorDocument).bind(null, variables),
    ...options,
  });
};

useVendorQuery.document = VendorDocument;

useVendorQuery.getKey = (variables: VendorQueryVariables) => ['Vendor', variables];

export const VendorsDocument = `
    query Vendors {
  vendors {
    ...VendorFragment
  }
}
    ${VendorFragmentFragmentDoc}`;

export const useVendorsQuery = <TData = VendorsQuery, TError = { message: string; code: number }>(
  variables?: VendorsQueryVariables,
  options?: Omit<UseQueryOptions<VendorsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<VendorsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<VendorsQuery, TError, TData>({
    queryKey: variables === undefined ? ['Vendors'] : ['Vendors', variables],
    queryFn: useFetcher<VendorsQuery, VendorsQueryVariables>(VendorsDocument).bind(null, variables),
    ...options,
  });
};

useVendorsQuery.document = VendorsDocument;

useVendorsQuery.getKey = (variables?: VendorsQueryVariables) =>
  variables === undefined ? ['Vendors'] : ['Vendors', variables];
